/* Generated from lib/guide/registry.ts by `npm run guide:locale`. Edit the registry's English,
 * then regenerate; translations live in locales/<lang>/guide.ts with the same keys. */
/* Arabic (Modern Standard Arabic) translation of the in-app User guide. Keys match locales/en-US/guide.ts. */
export const guide = {
  "chapters": {
    "getting-started": {
      "title": "البدء",
      "description": "سجّل الدخول، وأعدّ مساحة العمل، وحقّق أول نتيجة لك."
    },
    "assets": {
      "title": "الأصول والمواقع",
      "description": "سجّل الأصول، واجمعها في مواقع، وأكمل بياناتها."
    },
    "inspections": {
      "title": "الفحوصات والصيانة",
      "description": "افحص الأصول بقوائم التحقق، وحافظ على مواعيد الأعمال المتكررة."
    },
    "jobs": {
      "title": "العمل والمهام",
      "description": "قائمة واحدة بكل ما يجب إنجازه، ثم كلّف بالمهام وأسندها وأكملها."
    },
    "requests": {
      "title": "الطلبات",
      "description": "أبلغ عن المشكلة مرة واحدة وتابعها حتى إنجازها في حالة واحدة."
    },
    "contractors": {
      "title": "المقاولون وعروض الأسعار",
      "description": "استعن بمقاولين خارجيين وقارن بين عروض الأسعار."
    },
    "reviews": {
      "title": "التقارير والرؤى والامتثال",
      "description": "شارك التقارير، واقرأ الاتجاهات، وأثبت الامتثال."
    },
    "team": {
      "title": "الفريق وجهات الاتصال",
      "description": "أضف الأشخاص، وكوّن الفرق، وأدر صلاحيات الوصول."
    },
    "integrations": {
      "title": "التكاملات والأتمتة",
      "description": "اربط الأنظمة الأخرى، وأتمت العمليات، واستورد بياناتك."
    },
    "billing": {
      "title": "الفوترة وأرصدة الذكاء الاصطناعي",
      "description": "افهم خطتك واستخدامك وأرصدة الذكاء الاصطناعي."
    },
    "account": {
      "title": "الحساب والاستمرارية",
      "description": "واصل العمل دون اتصال، واستعد عملك بأمان."
    }
  },
  "articles": {
    "welcome": {
      "title": "مرحبًا بك في AssetWRX",
      "summary": "ما هو AssetWRX، وكيف نُظّم هذا الدليل.",
      "whyItMatters": "كل شيء مرتبط بأصل، فلا يبقى فحص أو إصلاح أو مستند معزولًا وحده، ويتبع هذا الدليل طريقة عملك الفعلية.",
      "timeEstimate": "قراءة لمدة دقيقتين",
      "intro": "AssetWRX هو نظام التشغيل لأصولك المادية: مكان واحد تسجّل فيه ما تملكه، وتفحص حالته، وتكلّف بالأعمال، وتُبقي الجميع على اطلاع.",
      "paragraphs": {
        "0": "كل شيء في AssetWRX مرتبط بأصل. من الأصل يمكنك إجراء فحص، أو رفع طلب، أو التكليف بمهمة، أو إرفاق مستندات، أو مشاركة الوصول، ويبقى كل ذلك مرتبطًا بالأصل فلا يفقد أي شيء سياقه.",
        "1": "يتبع الدليل دورة العمل المعروضة أعلى هذه الشاشة: أضف الأصول، وافحصها، ودع الناس يبلّغون عن المشكلات، ونفّذ العمل، ثم راجع وشارك. اضغط على مرحلة في الدورة لفتح صفحتها، أو على كيف يعمل لقراءة شرحها. وتتناول الفصول اللاحقة المقاولين وفريقك والتكاملات والفوترة ومواصلة العمل دون اتصال.",
        "2": "تحتوي كثير من المقالات الإرشادية على زر «أرني» الذي يشغّل جولة تفاعلية على الشاشة الحقيقية، فتتعلم بالممارسة. ويقدّم «أرشدني» في قائمة + جولات للمهام الشائعة في أي وقت."
      }
    },
    "finding-your-way": {
      "title": "التنقل في AssetWRX",
      "summary": "القائمة الجانبية وقائمة «المزيد» على الهاتف، مجموعة بمجموعة.",
      "whyItMatters": "كل قسم على بُعد نقرة واحدة، ومجمّع بالطريقة التي تعمل بها، فلا تبحث عن صفحة أبدًا.",
      "timeEstimate": "دقيقة واحدة للقراءة",
      "intro": "على الجهاز اللوحي أو الحاسوب، تعرض القائمة الجانبية كل أقسام AssetWRX مجمّعة بالطريقة التي تعمل بها. وعلى الهاتف تجد الأقسام نفسها في الشريط السفلي وفي «المزيد».",
      "paragraphs": {
        "0": "«الرئيسية» في الأعلى. تضم «العمل» «العمل» و«التقويم». وتضم «إدارة» «المواقع» و«الأصول» و«جهات الاتصال» و«قوائم التحقق» و«قواعد المجموعات». وتضم «رؤى» «الرؤى» و«الامتثال» و«قاعدة المعرفة».",
        "1": "يبقى «المساعدة» و«الحساب» (اسمك وصورتك) أسفل القائمة. وفي النافذة القصيرة تُمرَّر المجموعات ويبقى «المساعدة» و«الحساب» ظاهرين.",
        "2": "على شاشة أضيق، مثل iPad، تعرض القائمة الرموز فقط مع خط رفيع بين المجموعات. اضغط السهم في الأعلى لفتح القائمة بالأسماء فوق الصفحة؛ اختر قسمًا فتُغلق. وعلى الشاشة العريضة يوسّع السهم نفسه القائمة أو يضيّقها، ويتذكر AssetWRX اختيارك.",
        "3": "ما لا تتضمنه خطتك يظهر تحت «ترقية للاستخدام» مع قفل. اضغط عليه لترى الخطة التي تتضمنه.",
        "4": "على الهاتف، تجد «الرئيسية» و«الأصول» و«العمل» في الشريط السفلي، وتستخدم «المزيد» مجموعات القائمة الجانبية نفسها. تضم «العمل» «التقويم». وتضم «إدارة» «المواقع» و«جهات الاتصال» و«قوائم التحقق» و«قواعد المجموعات». وتضم «رؤى» «الرؤى» و«الامتثال» و«قاعدة المعرفة» و«النشاط». وما لا تتضمنه خطتك يظهر تحت «ترقية للاستخدام»، ويأتي «المساعد» و«المساعدة» و«الحساب» في الأسفل."
      }
    },
    "signing-in": {
      "title": "تسجيل الدخول",
      "summary": "الوصول إلى عملك بسرعة وأمان.",
      "whyItMatters": "أمان لا يعترض طريقك: تصل مباشرة إلى المهمة التي جئت من أجلها، حتى من رابط مباشر، بدلًا من قائمة.",
      "timeEstimate": "قراءة لمدة دقيقتين",
      "intro": "تسجيل الدخول بوابة سريعة وليس طريقًا جانبيًا، إذ ينقلك AssetWRX مباشرة إلى ما جئت من أجله.",
      "paragraphs": {
        "0": "سجّل الدخول ببريدك الإلكتروني وكلمة المرور، أو اختر «متابعة باستخدام Google» أو «متابعة باستخدام Apple» أو «متابعة باستخدام Microsoft».",
        "1": "إذا فعّلت المصادقة الثنائية («الحساب ← الأمان»)، فأدخل رمز التحقق من تطبيق المصادقة بعد كلمة المرور.",
        "2": "إذا فتحت رابطًا لسجل معيّن وأنت غير مسجّل الدخول، يتذكره AssetWRX ويفتح تلك الشاشة نفسها بعد تسجيل دخولك.",
        "3": "نسيت كلمة المرور؟ اضغط «نسيت كلمة المرور؟» في شاشة تسجيل الدخول، ثم «إرسال الرابط». افتح الرسالة واختر كلمة مرور جديدة.",
        "4": "يمكنك تغيير بريدك الإلكتروني أو كلمة المرور من «الحساب ← الأمان ← طريقة تسجيل دخولك». ومن المكان نفسه تشغّل تسجيل الدخول باستخدام Face ID أو بصمة الإصبع أو توقفه، في تطبيق الهاتف والجهاز اللوحي فقط."
      }
    },
    "create-account-workspace": {
      "title": "أنشئ حسابك ومساحة العمل",
      "summary": "الحد الأدنى من الإعداد للوصول إلى نتيجة حقيقية بسرعة.",
      "whyItMatters": "ابدأ الاستفادة خلال دقائق، فلا تضيف هيكلًا مثل الفرق والمواقع إلا عندما تحتاج إليه فعلًا، وليس من البداية.",
      "timeEstimate": "قراءة لمدة 3 دقائق",
      "intro": "الإعداد خياران سريعان ثم أول إجراء لك، ولن تحتاج إلى التدرّب على الوحدات مسبقًا.",
      "paragraphs": {
        "0": "بعد التسجيل، تسألك شاشة «إعداد مساحة العمل» عمّا تديره، سواء كان عقارات أو أسطولًا أو معدات أو مرافق أو مزيجًا منها، ليبدأ AssetWRX معك بقوائم تحقق تناسبه، وتسألك عن اسم مساحة العمل. يمكنك تغيير الاسم أو إزالة قوائم التحقق الأولية لاحقًا.",
        "1": "ثم اختر أول نتيجة مفيدة لك: «أضف أصلي الأول»، أو «جرّب فحصًا تدريبيًا» (مع أصل تجريبي يمكنك إزالته في أي وقت)، أو «الانتقال إلى الرئيسية». البدء بأصل حقيقي هو أسرع طريق إلى الفائدة.",
        "2": "بعد ذلك تعرض الرئيسية قائمة قصيرة بعنوان «ابدأ خلال دقيقة»: سجّل أصلًا، وشاركه، وجدول فحصًا أو مهمة، وادعُ جهات الاتصال، إلى جانب ما يحتاج إليك بعد ذلك. الفرق اختيارية: أضف فريقًا لاحقًا (راجع «الفريق وجهات الاتصال») وانقل الأصول إليه عندما تكون مستعدًا."
      }
    },
    "add-your-first-asset": {
      "title": "أضف أصلك الأول",
      "summary": "سجّل شيئًا تعمل عليه، فكل ما تحتاج إليه هو اسم ونوع.",
      "whyItMatters": "أصلك الأول يفتح كل شيء آخر: الفحوصات والمهام والطلبات والمستندات ورؤى الذكاء الاصطناعي كلها تبدأ من هنا.",
      "timeEstimate": "دقيقتان",
      "intro": "الأصول هي قلب AssetWRX. إضافة أصل تتطلب قرارين: اسمه، ونوعه. ويمكن ملء كل شيء آخر لاحقًا.",
      "preview": {
        "screen": "الأصول",
        "rows": {
          "0": "المضخة 12",
          "1": "الغلاية 3",
          "2": "الرافعة الشوكية أ"
        },
        "highlight": "إضافة أصل",
        "pin": "اضغط للبدء"
      }
    },
    "assets-overview": {
      "title": "العمل مع الأصول",
      "summary": "ابحث عن أصل أو أنشئه، واتخذ أفضل إجراء تالٍ.",
      "whyItMatters": "صورة كاملة ومحدّثة دائمًا لما تملكه، مع أفيد إجراء تالٍ على بُعد ضغطة واحدة، فلا تعيقك الأعمال الإدارية أبدًا.",
      "timeEstimate": "قراءة لمدة 3 دقائق",
      "intro": "يعرض تبويب «الأصول» كل ما تديره، ومعه «المواقع». افتح أصلًا لترى حالته وسجله ومستنداته والإجراءات المتاحة عليه.",
      "paragraphs": {
        "0": "تضم قائمة + في الأصل كل ما يمكنك فعله به، على الهاتف أو الجهاز اللوحي أو الحاسوب: «فحص»، و«أضف مهمة»، و«بلّغ عن مشكلة»، و«إضافة خطة»، و«أضف قراءة»، و«أضف مستندًا»، و«إضافة مقالة»، و«مشاركة»، و«أضف جهة اتصال»، و«اربط أصلًا»، و«نقل»، و«Asset 360»، ويبقى كل منها مرتبطًا بالأصل. ويرشدك «أرشدني» في القائمة نفسها خطوة بخطوة في أي منها.",
        "1": "لا تحتاج إلى ملء كل شيء من البداية. سجّل الأصل الآن باسم ونوع، ثم أكمل بياناته (التفاصيل، والمستندات، والموقع، والعلاقات) مع الوقت، فالبيانات الأغنى تعني رؤى وتقارير أفضل من الذكاء الاصطناعي.",
        "2": "يساعدك «بحث» و«تصفية» أعلى القائمة على الوصول مباشرة إلى أصل معيّن. تبدّل «الأماكن» و«المعدّات» و«المركبات» أعلى القائمة بين الأنواع الثلاثة؛ ويعرض «الكل» كل شيء بما فيه «أخرى».",
        "3": "تعرض «التقارير»، بجانب «العمل» في صفحة الأصل، كل تقارير الفحص والمهام الخاصة بالأصل، الأحدث أولًا. وتضيّق «كل التقارير» و«في انتظار المراجعة» و«موقَّع عليه» القائمة. وللموقع علامة «التقارير» نفسها."
      }
    },
    "places-equipment-vehicles": {
      "title": "الأماكن والمعدّات والمركبات",
      "summary": "المباني والطوابق والغرف أماكن؛ وما يُركّب فيها معدّات؛ وللمركبات موقع أساسي.",
      "whyItMatters": "يُقرأ المستشفى أو الفندق أو مركز البيانات كما بُني: كل غرفة وخزانة وغرفة معدّات في مبناها، وكل جهاز في الغرفة التي يوجد فيها.",
      "timeEstimate": "3 دقائق قراءة",
      "intro": "كل أصل من أحد ثلاثة أنواع، أو «أخرى». المكان مبنى أو جناح أو طابق أو غرفة أو قسم أو خزانة أو موقف سيارات أو أي منطقة أخرى. المعدّات هي ما يُركّب أو يُستخدم هناك. المركبة تتحرك، لذا لا توجد داخل أي شيء ولها موقع أساسي بدلًا من ذلك.",
      "paragraphs": {
        "0": "عند إضافة مكان، اختر نوعه: مبنى أو طابق أو غرفة وغيرها. الأماكن التي أضفتها سابقًا من نوع «عقار»، فلا يتغير شيء مما لديك.",
        "1": "كل أصل يوجد في مكان واحد على الأكثر، ويظهر بعنوان «يوجد في» في النموذج و«أين يوجد» على الأصل: المبنى A › الطابق 3 › الغرفة 301. المكان لا يوجد إلا داخل مكان آخر. أما المعدّات فقد توجد في مكان أو مركبة أو عنصر آخر، مثل مضخة في غرفة معدّات أو رافعة خلفية على شاحنة.",
        "2": "على المكان، ينشئ «إضافة مكان بداخله» و«إضافة معدّات هنا» المستوى التالي مع تعبئة «يوجد في» مسبقًا. يغيّر «نقل» مكان وجود العنصر، ويُبقيه «إخراج» في موقعه لكن خارج أي شيء.",
        "3": "تعرض قائمة «الأماكن» الشجرة: كل مكان مُزاح تحت المكان الذي يحتويه. يعدّ الموقع الأماكن والمعدّات والمركبات كلًّا على حدة، وكل مكان، بما فيه الغرفة، أصل ضمن خطتك.",
        "4": "لا يزال «ربط أصل» يسجل الروابط الأخرى، مثل ما تعتمد عليه المضخة أو ما يراقبه المستشعر. إذا وضع رابط قديم عنصرًا في مكانين، ينبّهك الأصل ويسألك أيهما تُبقي."
      },
      "preview": {
        "screen": "الأصول · الأماكن",
        "rows": {
          "0": "المبنى A",
          "1": "  الطابق 3",
          "2": "    الغرفة 301"
        },
        "highlight": "الأماكن",
        "pin": "شجرة واحدة"
      }
    },
    "custom-asset-types": {
      "title": "أنواع الأصول الخاصة بك",
      "summary": "أضف أنواعًا مثل مبرّد أو غرفة نزلاء أو مضخة تسريب، لكلٍّ منها التفاصيل التي يطلبها.",
      "whyItMatters": "كل مبرّد يسجّل غاز التبريد والقدرة بالطريقة نفسها، فتستطيع التقارير والمساعد الذكي وPower BI المقارنة بينها.",
      "timeEstimate": "3 دقائق",
      "intro": "يفتح المالكون والمسؤولون الحساب ← مساحة العمل ← أنواع الأصول، على الهاتف أو الجهاز اللوحي أو الحاسوب، ويضغطون «إضافة نوع أصل». أعطه اسمًا، وحدّد هل هو مكان أو معدّات أو مركبة أو أخرى، وأضف التفاصيل المطلوب تعبئتها.",
      "paragraphs": {
        "0": "يمكن أن تكون التفصيلة نصًا أو رقمًا بوحدة أو تاريخًا أو خيارًا من قائمة أو نعم/لا. اجعلها إلزامية عندما يحتاجها كل أصل من هذا النوع.",
        "1": "عند إضافة أصل أو تعديله، اختر النوع ضمن «نوع الأصل» (أو «نوع المكان» للمكان) فتظهر تفاصيله في النموذج. وتظهر على الأصل ضمن «أين يوجد».",
        "2": "النوع المستخدم يحتفظ بفئته، والتفصيلة التي لها قيم تحتفظ بصيغتها، حتى لا يفسد شيء مسجّل. أرشِف النوع الذي لم تعد تضيفه؛ وتحتفظ الأصول التي تستخدمه به وبتفاصيلها.",
        "3": "يمكن توجيه قوائم التحقق إلى أنواعك وأنواع الأماكن: افتح القائمة ثم «تفاصيل قائمة التحقق وإمكانية رؤيته»، واختر ضمن «أنواع الأصول الخاصة بك» أو «أنواع الأماكن»."
      },
      "preview": {
        "screen": "أنواع الأصول",
        "rows": {
          "0": "الاسم · مبرّد",
          "1": "غاز التبريد · اختيار من قائمة",
          "2": "القدرة · رقم (t)"
        },
        "highlight": "حفظ",
        "pin": "عرّفه مرة واحدة"
      }
    },
    "set-up-a-building-in-one-go": {
      "title": "إعداد مبنى دفعة واحدة",
      "summary": "أنشئ مبنى كاملًا طابقًا بطابق من قالب مثل فندق أو مستشفى، وشاهد أولًا ما يضيفه إلى فاتورتك.",
      "whyItMatters": "فندق من 300 غرفة يحتاج إلى شاشة واحدة بدل فترة بعد الظهر كاملة، وكل غرفة في طابقها الصحيح من البداية.",
      "timeEstimate": "3 دقائق",
      "intro": "في موقع، اضغط «إعداد مبنى» (موجود أيضًا في قائمة الأصول). اختر نوع المبنى، وسمّه، وحدّد عدد الطوابق وعدد الغرف أو الأجنحة أو الوحدات في كل طابق.",
      "paragraphs": {
        "0": "يأتي كل نوع مبنى بالإضافات المعتادة، مثل الاستقبال والصالة الرياضية والمسابح في الفندق، أو غرفة معدّات في الطابق الأعلى. حدّد ما تريده. الأماكن المشتركة مثل موقف السيارات تكون على مستوى الموقع لا داخل المبنى، ولا تظهر إلا إذا لم تكن في الموقع بعد.",
        "1": "يمكن للمالكين والمسؤولين أيضًا إضافة أنواع الأصول المعتادة لهذا النوع من المباني مع تفاصيلها، مثل غرفة نزلاء ومصعد وباب حريق للفندق. ويُعاد استخدام الأنواع الموجودة لديك.",
        "2": "قبل إنشاء أي شيء ترى قائمة الأماكن ومربع الفوترة: كم أصلًا جديدًا سيُنشأ، وكم سيصبح لديك، وكم ستصبح تكلفتك الشهرية. كل مكان أصل محتسب في الفاتورة. وإذا تجاوز المجموع ما تسمح به خطتك، يبقى «إنشاء» معطلًا حتى تغيّر الخطة أو تنشئ عددًا أقل.",
        "3": "الموقع متعدد الاستخدامات، مثل مكاتب فوق متاجر، يُعَدّ مبنى تلو الآخر، ولكلٍّ نوعه. ويعطي «شيء آخر» طوابق وغرفًا فقط.",
        "4": "لإضافة سلسلة مرقّمة داخل مكان واحد، افتح المكان واضغط «إضافة عدة عناصر في الداخل». استخدم # في نمط الاسم للرقم: «غرفة ##» تعطي غرفة 01، غرفة 02."
      },
      "preview": {
        "screen": "إعداد مبنى",
        "rows": {
          "0": "نوع المبنى · فندق",
          "1": "الطوابق · 6",
          "2": "عدد الغرف في كل طابق · 20"
        },
        "highlight": "إنشاء",
        "pin": "التكلفة تظهر أولًا"
      }
    },
    "rounds-and-place-rollups": {
      "title": "الجولات وما داخل المكان",
      "summary": "تجوّل في طابق أو مبنى كعمل واحد بقائمة محطات، وشاهد كل ما داخل المكان بنظرة واحدة.",
      "whyItMatters": "جولة التنظيف أو فحص أبواب الحريق عمل واحد يُسنَد ويُتابَع، وتحتفظ كل غرفة بإجاباتها.",
      "timeEstimate": "3 دقائق",
      "intro": "في مكان، اضغط «بدء جولة». اختر قائمة التحقق، وضيّق المحطات حسب الفئة أو النوع أو المنطقة، وألغِ تحديد ما تريد تخطيه، وحدّد تاريخًا إن شئت.",
      "paragraphs": {
        "0": "ينشئ «بدء الجولة» عملًا واحدًا على المكان. كل محطة فحص في هذا العمل بالترتيب، وفتح المحطة يبدأ فحصًا على أصلها، فتبقى الإجابات والصور على الغرفة أو العنصر نفسه.",
        "1": "يمكن أن تضم الجولة حتى 200 محطة. ويُنهى العمل كأي عمل آخر بعد إتمام فحوصه المطلوبة.",
        "2": "يعرض المكان الذي يحتوي على أصول أخرى ملخصًا تحت «أين يقع»: كم مكانًا ومعدّة ومركبة بداخله، وكم منها بخطر مرتفع، والأعمال المفتوحة والزيارات المستحقة. ويفتح «عرض كل الأعمال في الداخل» تبويب العمل للمكان وكل ما فيه، مجمّعًا حسب الأصل."
      },
      "preview": {
        "screen": "جولة فحص: الطابق 3",
        "rows": {
          "0": "المحطة 1: غرفة 301",
          "1": "المحطة 2: غرفة 302",
          "2": "المحطة 3: غرفة 303"
        },
        "highlight": "بدء الجولة",
        "pin": "عمل واحد، محطات كثيرة"
      }
    },
    "group-rules": {
      "title": "قواعد المجموعات",
      "summary": "قائمة تحقق واحدة على مجموعة كاملة من الأصول بجدول واحد: كل باب حريق في المبنى A، شهريًا.",
      "whyItMatters": "تحل قاعدة واحدة محل مئات الجداول المنفصلة، وتُضم الأصول الجديدة المطابقة دون أن يتذكر أحد إضافتها.",
      "timeEstimate": "4 دقائق",
      "intro": "تحدد قاعدة المجموعة أي أصول، وأي قائمة تحقق، وكم مرة، ومن متى. وعند حفظها يُنشأ فحص مجدول عادي لكل أصل في المجموعة، فتتعامل معه التذكيرات والمخطط والتقارير مثل أي فحص آخر.",
      "paragraphs": {
        "0": "افتح قواعد المجموعات: المزيد ← قواعد المجموعات على الهاتف، أو قواعد المجموعات في القائمة الجانبية على الجهاز اللوحي أو الكمبيوتر، أو قواعد المجموعات أعلى قوائم التحقق. يرى الجميع القواعد؛ ويضيفها المالكون والمسؤولون ويعدّلونها ويوقفونها. وزر إضافة قاعدة مجموعة على مكان يفتح النموذج مضبوطًا على ذلك المكان.",
        "1": "حدّد الأصول: اختر فئة (مكان أو معدات أو مركبة أو أخرى)، ثم ضيّقها إلى نوع مكان أو أحد أنواع الأصول لديك، مثل باب حريق. وتحت أين، اترك في أي مكان أو اختر مكانًا مثل المبنى A لتأخذ ما بداخله فقط، على كل مستوى. والمنطقة تضيّقها أكثر. ولا تؤخذ إلا الأصول النشطة.",
        "2": "اختر قائمة التحقق، وكم مرة، وتاريخ أول فحص. ويمكنك أيضًا إسناد الفحوصات إلى شخص واحد يُبلَّغ مرة واحدة. ويلخّص النموذج القاعدة في جملة واحدة ويذكر عدد الأصول التي تأخذها الآن.",
        "3": "مثال: «فحص شهري لأبواب الحريق» يأخذ كل باب حريق داخل المبنى A. في المبنى A أربعة وعشرون بابًا، فيُنشئ الحفظ 24 فحصًا كلها مستحقة في التاريخ الأول. وتظهر في صفحة العمل كصف واحد، «فحص شهري لأبواب الحريق · 24 أصلًا»؛ اضغطه لفتح القاعدة. وعند إنجاز فحص باب يُخطَّط فحصه الشهري التالي.",
        "4": "تستمر القاعدة في العمل بعد الحفظ. باب الحريق الجديد في المبنى A، أو الذي يُنقل إليه، يحصل على فحصه الخاص مستحقًا في يوم انضمامه. والباب الذي يُنقل إلى خارجه أو يُؤرشف أو يتغير نوعه يُلغى فحصه الذي لم يبدأ.",
        "5": "تعديل القاعدة يغيّر فحوصاتها التي لم تبدأ: قائمة التحقق الجديدة أو التكرار أو الشخص أو الاسم يُنقل إليها، والتاريخ الأول الجديد ينقل الفحوصات الأولى، والأصول التي لم تعد مطابقة تُلغى فحوصاتها. وقبل الحفظ يذكر النموذج عدد ما سيتغير. أما الفحوصات التي بدأت أو انتهت فلا تتغير أبدًا.",
        "6": "أوقف القاعدة لإلغاء الفحوصات التي أنشأتها ولم تبدأ. وتبقى الفحوصات المنتهية ونتائجها. وأعد تشغيلها لتخطيطها من جديد. وكل فحص أنشأته قاعدة يظهر عليه من قاعدة مجموعة مع رابط إلى القاعدة."
      },
      "preview": {
        "screen": "قواعد المجموعات",
        "rows": {
          "0": "فحص شهري لأبواب الحريق",
          "1": "باب حريق · داخل المبنى A · شهريًا",
          "2": "24 فحصًا مفتوحًا"
        },
        "highlight": "إضافة قاعدة مجموعة",
        "pin": "قاعدة واحدة، أصول كثيرة"
      }
    },
    "zones": {
      "title": "المناطق",
      "summary": "ضع على الأصول مناطق تمتد عبر الأماكن، مثل منطقة الحريق 2 أو الجناح الشرقي.",
      "whyItMatters": "نادرًا ما تطابق منطقة الحريق أو منطقة التنظيف مبنى واحدًا أو طابقًا واحدًا. والمنطقة تتيح لقاعدة مجموعة أو جولة أن تأخذ تلك الأصول بالضبط.",
      "timeEstimate": "دقيقة واحدة",
      "intro": "المنطقة وسم يمتد عبر الأماكن، مثل منطقة الحريق 2 أو الجناح الشرقي. أضف المناطق في نموذج الأصل تحت المناطق، مفصولة بفواصل.",
      "paragraphs": {
        "0": "يمكن أن يكون للأصل عدة مناطق. وتطابق قاعدة المجموعة المنطقة دون اعتبار لحالة الأحرف، فـ East wing وeast wing منطقة واحدة.",
        "1": "استخدم منطقة في قاعدة مجموعة لتأخذ الأصول الموسومة بها فقط، أو لتضييق محطات جولة."
      },
      "preview": {
        "screen": "تعديل الأصل",
        "rows": {
          "0": "الاسم · باب حريق 3.12",
          "1": "المناطق · منطقة الحريق 2، الجناح الشرقي"
        },
        "highlight": "حفظ",
        "pin": "وسوم، لا أماكن"
      }
    },
    "create-a-site": {
      "title": "أنشئ موقعًا",
      "summary": "اجمع الأصول تحت مكان واحد، مثل مبنى أو مجمّع أو مستودع.",
      "whyItMatters": "التجميع حسب المكان يجعل التقارير والتسليم والمساءلة تتبع الواقع، فأنت تدير موقعًا لا قائمة متفرقة.",
      "timeEstimate": "دقيقتان",
      "intro": "افتح «المواقع» («المزيد ← المواقع» على الهاتف)، واضغط +، ثم «موقع». الاسم وحده هو المطلوب، ثم اضغط «إنشاء الموقع». يُفتح الموقع على «نظرة عامة»، وعلاماته هي «نظرة عامة» و«التفاصيل» (العنوان والنوع والفريق والتواريخ) و«الأصول» و«العمل» و«التقارير» و«الأشخاص».",
      "preview": {
        "screen": "المواقع",
        "rows": {
          "0": "المستودع الشمالي",
          "1": "المكتب الرئيسي"
        },
        "highlight": "موقع",
        "pin": "أنشئ مكانًا"
      }
    },
    "add-assets-to-a-site": {
      "title": "أضف أصولًا إلى موقع",
      "summary": "انقل الأصول الموجودة إلى موقع.",
      "whyItMatters": "اطّلع على موقع كامل وأدره دفعة واحدة بدلًا من أصل تلو الآخر: أصوله وأعماله المفتوحة ومخاطره في مكان واحد.",
      "timeEstimate": "دقيقة واحدة",
      "intro": "افتح الموقع، واضغط +، ثم «تعيين أصل» واختر الأصل. ستظهر رسالة تؤكد نقله. يمكنك إضافة المزيد في أي وقت.",
      "preview": {
        "screen": "المستودع الشمالي",
        "rows": {
          "0": "12 أصلًا",
          "1": "الفريق · المرافق"
        },
        "highlight": "تعيين أصل",
        "pin": "عيّن الأصول"
      }
    },
    "attach-documents": {
      "title": "أرفق المستندات",
      "summary": "احتفظ بالشهادات والضمانات ومستندات الامتثال على الأصل.",
      "whyItMatters": "لن يفوتك انتهاء شهادة أو ضمان بعد الآن: يبقى الامتثال على الأصل مع تذكيرات بالتجديد، فلا تتحول عمليات التدقيق إلى سباق مع الوقت.",
      "timeEstimate": "دقيقتان",
      "intro": "تُحفظ المستندات على الأصل، مع تذكير بالتجديد قبل انتهائها، فلا تنتهي صلاحية الشهادات والضمانات دون أن يلاحظ أحد.",
      "paragraphs": {
        "0": "افتح الأصل، واضغط +، ثم «أضف مستندًا». اختر «نوع المستند بالتحديد»، وأضف الملف، وأدخل تاريخ الانتهاء إن وُجد.",
        "1": "لتغيير تاريخ أو عنوان لاحقًا، افتح المستند واضغط «تعديل التفاصيل». لا تحتاج إلى رفع الملف مرة أخرى.",
        "2": "تحصل الشهادات التي لها تاريخ انتهاء على تذكير قبل انتهائها، وتظهر في قائمة «الامتثال»."
      },
      "preview": {
        "screen": "المضخة 12 · المستندات",
        "rows": {
          "0": "الضمان.pdf",
          "1": "شهادة سلامة الغاز.pdf"
        },
        "highlight": "إضافة مستند",
        "pin": "أضف ملفًا"
      }
    },
    "add-knowledge": {
      "title": "أضف معرفة إلى أصل",
      "summary": "احتفظ بالإرشادات والأسئلة الشائعة والملاحظات حيث يجري العمل.",
      "whyItMatters": "ما تعلّمه أحد المهندسين لم يعد يرحل معه: يجد الشخص التالي إجراء إعادة الضبط على الأصل، لا في ذاكرة أحد.",
      "timeEstimate": "دقيقتان",
      "intro": "المعرفة هي ما يعرفه فريقك عن الأصل: الإرشادات، والأسئلة الشائعة، والملاحظات، والروابط، والملفات. في الأصل، اختر «أرشدني ← إضافة معرفة»، أو «إضافة مقالة» في قائمة +.",
      "paragraphs": {
        "0": "اختر النوع، وأعطه عنوانًا سيبحث عنه الناس، واكتب المحتوى. يمكنك إملاؤه وأنت في الموقع، أو ترك الذكاء الاصطناعي يحوّل الملاحظات الأولية إلى خطوات واضحة.",
        "1": "يبحث «قاعدة المعرفة» في المقالات عبر جميع الأصول: «المزيد ← قاعدة المعرفة» على الهاتف، أو «قاعدة المعرفة» في القائمة الجانبية على الجهاز اللوحي أو الحاسوب."
      },
      "preview": {
        "screen": "الغلاية 3 · المعرفة",
        "rows": {
          "0": "النوع · طريقة",
          "1": "العنوان · إجراء إعادة ضبط الغلاية"
        },
        "highlight": "حفظ",
        "pin": "اكتبها مرة واحدة"
      }
    },
    "move-an-asset": {
      "title": "سجّل مكان الأصل",
      "summary": "سجّل نقلًا، أو صحّح موقعًا كان خاطئًا.",
      "whyItMatters": "سجلّ بالأماكن التي كانت فيها الأشياء، وسبب نقلها، ينهي البحث عن مضخة نُقلت العام الماضي.",
      "timeEstimate": "دقيقة واحدة",
      "intro": "عندما يُنقل أصل، سجّل ذلك على الأصل: اختر «أرشدني ← تسجيل نقل»، أو «نقل» في قائمة +.",
      "paragraphs": {
        "0": "حدّد ما إذا كان قد نُقل فعلًا أم سُجّل خطأً. النقل يحتفظ بالموقع القديم في السجل مع وقت النقل وسببه، أما التصحيح فيصلح السجل فقط."
      },
      "preview": {
        "screen": "الشاحنة 7 · نقل",
        "rows": {
          "0": "نُقل · اليوم",
          "1": "أين هو الآن؟ · المستودع 2"
        },
        "highlight": "تسجيل النقل",
        "pin": "نُقل أم صُحّح"
      }
    },
    "relate-assets": {
      "title": "اربط الأصول ببعضها",
      "summary": "اربط الأصول لتنتقل المخاطر والأهمية بينها.",
      "whyItMatters": "اكتشف المشكلات المتسلسلة: عندما تظهر مشكلة في أصل، تظهر أيضًا على كل ما يعتمد عليه.",
      "timeEstimate": "دقيقتان",
      "intro": "افتح الأصل، واضغط +، ثم «اربط أصلًا». اختر الأصل الآخر، سواء كان ما ينتمي إليه، أو جزءًا منه، أو شيئًا يعتمد عليه، واضغط «إضافة علاقة».",
      "preview": {
        "screen": "المضخة 12 · الأصول المرتبطة",
        "rows": {
          "0": "الأصل الأم · غرفة المعدات",
          "1": "جزء · وحدة المحرك"
        },
        "highlight": "إضافة علاقة",
        "pin": "اربطه"
      }
    },
    "assign-asset-to-team": {
      "title": "أسند أصلًا إلى فريق",
      "summary": "انقل الأصل من «شخصي» ليتمكن الفريق من العمل عليه.",
      "whyItMatters": "يمتلك الأشخاص المناسبون الأصول المناسبة، فيصل العمل إلى الفريق تلقائيًا بدلًا من أن يقع عليك وحدك.",
      "timeEstimate": "دقيقة واحدة",
      "intro": "تبدأ الأصول في مساحة عملك الشخصية. اضغط «تغيير» بجانب «الفريق المسؤول» في الأصل لنقله إلى فريق، فيتمكن كل أعضاء ذلك الفريق من العمل عليه.",
      "preview": {
        "screen": "المضخة 12",
        "rows": {
          "0": "الفريق المسؤول · شخصي",
          "1": "الموقع · المستودع الشمالي"
        },
        "highlight": "تغيير",
        "pin": "غيّر المالك"
      }
    },
    "take-an-asset-out-of-service": {
      "title": "أخرج أصلًا من الخدمة",
      "summary": "أخرجه من الخدمة مع ذكر السبب، ومع مهمة تأمين إن احتاج إليها.",
      "whyItMatters": "الغلاية المتوقفة طوال الشتاء لا ينبغي أن تصبح متأخرة، ولا ينبغي أن يجد أحد مهمة عليها. الإخراج من الخدمة يوقف جداولها مؤقتًا، ويمنع الأعمال الروتينية، ويسجّل السبب، ويكون تقرير مهمة التأمين هو شهادة الإخراج من الخدمة.",
      "timeEstimate": "دقيقتان",
      "intro": "للأصل حالتان: هل السجل قائم (نشط، أو مؤرشف، أو خارج الخدمة نهائيًا)، وهل الأصل نفسه في الخدمة. الإخراج من الخدمة يغيّر الحالة الثانية: يبقى الأصل في سجلك مع تاريخه، لكنه خارج الخدمة حتى تعيد تشغيله.",
      "paragraphs": {
        "0": "اترك «اجعله آمنًا أولًا» مفعّلًا لإنشاء مهمة تجعل الأصل آمنًا: عزله، وتأمينه، ووضع ملصق عليه، وتصويره. يظهر على الأصل «جارٍ الإخراج من الخدمة» حتى يتم فحص تلك المهمة والتحقق منها. أوقفه لإخراج الأصل من الخدمة الآن، وعندها تضيف ملاحظة تذكر من اتخذ القرار.",
        "1": "ما دام الأصل خارج الخدمة، تتوقف أعماله المتكررة مؤقتًا وتُلغى الفحوصات القادمة مع ذكر السبب. يبقى سجله ومستنداته متاحة للقراءة، ويظل محسوبًا ضمن خطتك: الإخراج من الخدمة نهائيًا وحده يغلق السجل."
      },
      "preview": {
        "screen": "الغلاية 3",
        "rows": {
          "0": "في الخدمة · فريق المرافق",
          "1": "الفحص التالي · 12 أكتوبر"
        },
        "highlight": "إخراج من الخدمة",
        "pin": "ضمن ⋯"
      }
    },
    "bring-an-asset-back-into-service": {
      "title": "أعد أصلًا إلى الخدمة",
      "summary": "إعادة التشغيل: فحص ← مهام من النتائج ← تحقق ← في الخدمة.",
      "whyItMatters": "لا يعود الأصل إلى الخدمة إلا بإثبات: يُحفظ الفحص وكل مهمة نتجت عنه على الأصل كشهادة له.",
      "timeEstimate": "3 دقائق",
      "intro": "من شريط «خارج الخدمة» اختر «إعادة التشغيل» (أو «تشغيل» لأصل لم يكن في الخدمة من قبل). يفتح ذلك حالة تتابع الفحص والمهام حتى يعود الأصل.",
      "paragraphs": {
        "0": "ابدأ الفحص بأي قائمة تحقق. عند اكتماله، أنشئ مهامًا لكل ما لم يجتز الفحص. تنتهي كل مهمة بالتحقق من إصلاح المشكلة.",
        "1": "يصبح «إعادة إلى الخدمة» متاحًا بعد اكتمال الفحص والتحقق من كل مهمة نتجت عنه. يمكن للمسؤول التنازل عن ملاحظة لم تُحل مع إضافة ملاحظة تُدرج في الشهادة. وتُستأنف الجداول من اليوم."
      },
      "preview": {
        "screen": "الغلاية 3",
        "rows": {
          "0": "خارج الخدمة · نهاية العمر",
          "1": "الجداول متوقفة مؤقتًا"
        },
        "highlight": "إعادة التشغيل",
        "pin": "ابدأ من هنا"
      }
    },
    "retire-an-asset": {
      "title": "أخرج أصلًا من الخدمة نهائيًا",
      "summary": "أغلق السجل نهائيًا، مع توثيق طريقة التخلص منه.",
      "whyItMatters": "الأصل الخارج من الخدمة نهائيًا لا يمكن أن يحصل خفيةً على مهمة أو مشاركة أو فاتورة مرة أخرى، ويُحفظ سجل ما حدث له (بِيع، أو أُتلف، أو أُعيد) مع تاريخه الكامل للمدقق.",
      "timeEstimate": "دقيقتان",
      "intro": "أخرج من الخدمة نهائيًا الأصلَ الذي غادر الخدمة ولا توجد عليه أعمال جارية. إذا كان لا يزال في الخدمة، تعرض عليك النافذة إخراجه من الخدمة أولًا، وإذا كانت هناك مهام أو فحوصات مفتوحة، فإنها تذكرها.",
      "paragraphs": {
        "0": "اختر السبب، وأضف ملاحظة وبيانات التخلص منه: الطريقة، ومن استلمه، والقيمة. تعرض النافذة ما سيحدث قبل أن تؤكد: إلغاء المشاركات، وإيقاف رابط البلاغات العامة، وإنهاء الجداول، وإيقاف الفوترة عنه، وإخفاؤه من القوائم ومؤشرات الأداء.",
        "1": "اكتب «إنهاء» للتأكيد. تظهر الأصول الخارجة من الخدمة نهائيًا ضمن عرض «خارج الخدمة نهائيًا» في قائمة الأصول، ويبقى كل شيء فيها متاحًا للقراءة. وحده مسؤول مساحة العمل يمكنه استعادة أصل، ويعود الأصل خارج الخدمة، فأعد تشغيله لاستخدامه مرة أخرى."
      },
      "preview": {
        "screen": "الغلاية 3",
        "rows": {
          "0": "خارج الخدمة · استُبدل",
          "1": "لا يوجد عمل مفتوح"
        },
        "highlight": "إخراج الأصل من الخدمة نهائيًا",
        "pin": "ضمن ⋯"
      }
    },
    "run-an-inspection": {
      "title": "أجرِ فحصًا",
      "summary": "افحص أصلًا وفق قائمة تحقق ووثّق الأدلة.",
      "whyItMatters": "حوّل الحالة إلى دليل وإجراء: اكتشف المشكلات حين يكون إصلاحها رخيصًا، مع قائمة تحقق ينشئها الذكاء الاصطناعي إن لم تكن لديك واحدة بعد.",
      "timeEstimate": "4 دقائق",
      "intro": "تعتمد الفحوصات على قائمة تحقق. اختر «فحص» من قائمة + في الأصل، فيقترح AssetWRX قائمة تحقق مناسبة، وتبدأها «الآن» أو تجدولها «لاحقًا».",
      "paragraphs": {
        "0": "لا توجد قائمة تحقق مناسبة؟ اضغط «تغيير»، ثم «قائمة تحقق جديدة»، واختر «إنشاء بالذكاء الاصطناعي» لتحصل على مسودة لهذا الأصل، أو «إنشاء يدويًا».",
        "1": "يفتح الفحص المجدول على ابدأ والتفاصيل، و لا يمكنني الآن حيث تحتاج التغييرات إلى موافقة. يدخلك ابدأ مباشرة إلى الفحص، وعند الانتهاء تعود إلى القائمة التي بدأت منها.",
        "2": "بعد ذلك يعرض تأكيد المهام كل بند فاشل وكل إصلاح وافق عليه العميل، مع من ينفذه ومتى. اضغط تغيير أو تطبيق على الكل، ثم أنشئ وعيّن. الصياغة بالذكاء الاصطناعي اختيارية وتعرض الأرصدة أولاً.",
        "3": "يمكن إسناد الفحص إلى مقاول: في فحص جديد اختر «مقاول» تحت مسار العمل؛ وفي فحص موجود اختر إدارة، ثم إعادة الإسناد، ثم تعيين لمقاول. يحتاج إلى حساب AssetWRX. تظهر الزيارة المؤرخة وتكراراتها في عمله ويبدؤها من هناك بقائمة الفحص نفسها. وتعتمده أنت كالمعتاد."
      },
      "preview": {
        "screen": "الفحص · المضخة 12",
        "rows": {
          "0": "قائمة التحقق · عامة",
          "1": "متى · الآن"
        },
        "highlight": "بدء فحص",
        "pin": "ابدأ الفحص"
      }
    },
    "photo-checks-with-vision": {
      "title": "دع الصور تملأ قائمة التحقق (WRX Vision)",
      "summary": "التقط صورًا أثناء الفحص واحصل على إجابات مقترحة.",
      "whyItMatters": "أنهِ الفحوصات أسرع: التقط الصور مرة واحدة، ثم اقبل ما يقترحه Vision أو غيّره.",
      "timeEstimate": "قراءة لمدة 3 دقائق",
      "intro": "أثناء الفحص، اضغط «مسح» بجانب قسم في قائمة التحقق أو قراءة، أو «تحليل الصورة بالذكاء الاصطناعي» على بند. التقط الصور أو اخترها، وسيقترح Vision الإجابات.",
      "paragraphs": {
        "0": "لا يُحفظ شيء حتى تقبله. يعرض كل اقتراح ما رآه Vision. اقبله، أو غيّره، أو اتركه.",
        "1": "بعض الفحوصات تعمل على جهازك ولا تستهلك أي أرصدة. أما الفحوصات التي تحتاج إلى الإنترنت فتستهلك أرصدة الذكاء الاصطناعي، وتظهر التكلفة قبل أن تبدأ.",
        "2": "لا يظهر زر «مسح»؟ إما أن Vision غير مضمّن في خطتك، أو أن قائمة التحقق هذه لا تستخدم الصور في ذلك القسم."
      },
      "preview": {
        "screen": "الفحص · الغلاية 3",
        "rows": {
          "0": "فحوصات السلامة",
          "1": "قراءة الضغط"
        },
        "highlight": "مسح",
        "pin": "التقط الصور"
      }
    },
    "proactive-maintenance": {
      "title": "أعدّ الصيانة الاستباقية",
      "summary": "حوّل فحصًا لمرة واحدة إلى جدول متكرر.",
      "whyItMatters": "توقف عن إطفاء الحرائق: الفحوصات المجدولة تكتشف التآكل قبل أن يتحول إلى عطل، وهنا تكمن التوفيرات الحقيقية.",
      "timeEstimate": "دقيقتان",
      "intro": "اجعل الفحص يتكرر من تلقاء نفسه، ليُكتشف التآكل قبل أن يصبح عطلًا. في الأصل، اضغط +، ثم «أرشدني ← جدولة الفحوصات المتكررة»، أو اضغط «فحص» واختر «لاحقًا».",
      "paragraphs": {
        "0": "اضغط «لاحقًا»، واختر يوم ووقت أول فحص، ثم تحت «التكرار» اختر عدد مرات تكراره، مثل «كل شهر»، واضغط «جدولة الفحص». يمكنك أيضًا تحديد تاريخ انتهاء.",
        "1": "للأعمال المستحقة حسب الاستخدام وكذلك حسب التاريخ، مثل صيانة كل 12 شهرًا أو كل 10,000 ميل، استخدم خطة صيانة بدلًا من ذلك."
      },
      "preview": {
        "screen": "الفحص · المضخة 12",
        "rows": {
          "0": "متى · لاحقًا",
          "1": "التكرار · كل شهر"
        },
        "highlight": "التكرار",
        "pin": "كم مرة"
      }
    },
    "maintenance-plans": {
      "title": "خطط الصيانة وقراءات العدادات",
      "summary": "كرّر العمل حسب التاريخ، أو حسب الاستخدام، أو أيهما يحل أولًا.",
      "whyItMatters": "«12 شهرًا أو 10,000 ميل» خطة واحدة لا خطتان: يتتبع AssetWRX الاثنين وينشئ العمل عند حلول أولهما، فلا تفوتك صيانة ولا تتكرر.",
      "timeEstimate": "قراءة لمدة 3 دقائق",
      "intro": "خطة الصيانة هي خدمة أو اختبار أو فحص يتكرر، حسب التاريخ أو حسب العداد أو أيهما يحل أولًا. وهي تُنشئ العمل بنفسها عند استحقاقه.",
      "paragraphs": {
        "0": "في تبويب الصيانة للأصل، اضغط إضافة خطة. فعّل التكرار حسب التاريخ (كل N ساعات أو أيام أو أسابيع أو أشهر أو سنوات — التنظيف كل 4 ساعات خطة واحدة)، أو التكرار حسب العدّاد (المسافة أو ساعات التشغيل أو الدورات أو قراءة أخرى)، أو كليهما — ويعمل AssetWRX على ما يأتي أولًا. اذكر متى أُنجز آخر مرة؛ اتركه فارغًا إن لم يُنجز من قبل، فتدخل الزيارة الأولى إلى العمل فورًا. اختر مهمة أو فحصًا (بقائمة تحقق)، ومن ينفّذه — أو أقرّر في كل مرة.",
        "1": "الخطط التي تعتمد على الاستخدام تحتاج إلى قراءات. اضغط «تسجيل قراءة» في تبويب «الصيانة» في الأصل لإدخال قراءة. في تطبيق الهاتف أو الجهاز اللوحي يمكنك بدلًا من ذلك التقاط صورة للعداد فيقرأ التطبيق الرقم دون استهلاك أرصدة الذكاء الاصطناعي؛ أما على الويب فتُحفظ الصورة كدليل وتكتب الرقم بنفسك. تُحفظ القراءات على الجهاز عندما تكون غير متصل وتُزامن لاحقًا. والقراءة الأقل من السابقة لا تُحفظ إلا كتصحيح، مع ملاحظة توضح سبب خطأ القراءة السابقة.",
        "2": "يعرض تبويب الصيانة حالة كل خطة — مستحقة بعد 1,200 كم، مستحقة اليوم، متأخرة — ويعرض القادم التواريخ التالية؛ وتعرض مجموعة الخطوات كل خطوة في سطر مرقّم. يظهر عمل الخطة في العمل قبل موعده بما يصل إلى أسبوعين. وإن لم يُسمَّ أحد، يُطلب منك إسناده عند وصوله، مع تذكير قبل موعده بثلاثة أيام."
      },
      "preview": {
        "screen": "الشاحنة 7 · الصيانة",
        "rows": {
          "0": "الصيانة الدورية · التالية عند 40,000 ميل أو بحلول 1 مارس",
          "1": "المسافة المقطوعة · 36,120 ميل"
        },
        "highlight": "تسجيل قراءة",
        "pin": "حافظ على استمرار العدّ"
      }
    },
    "maintenance-steps": {
      "title": "اربط الخطط كخطوات",
      "summary": "رتّب الخطط المترابطة بالتسلسل، مثل صيانة 500 و1,000 و2,000 ساعة.",
      "whyItMatters": "لا ينبغي إنشاء صيانة كبرى بينما الصيانة الأصغر التي تسبقها لا تزال مفتوحة. تحافظ الخطوات على ترتيب العمل الصحيح، ويعرضها الأصل معًا كمجموعة واحدة.",
      "timeEstimate": "دقيقتان",
      "intro": "الخطوات هي خطط صيانة مترابطة على أصل واحد. أنشئ كل خطة أولًا عبر «إضافة خطة»، ثم اربطها في تبويب «الصيانة» في الأصل.",
      "paragraphs": {
        "0": "في تبويب «الصيانة» في الأصل، اضغط «ربط الخطط كخطوات» (يظهر عندما يكون للأصل خطتان). أعطِ الخطوات اسمًا، ثم اضغط «إضافة» بجانب كل خطة بترتيب حدوثها. استخدم السهمين لأعلى ولأسفل لتغيير الترتيب، و× لإزالة خطة. ثم اضغط «حفظ الخطوات».",
        "1": "اترك «تنفيذ الخطوات بالترتيب» مفعّلًا لتنتظر كل خطوة دورها: لا يُنشأ عملها إلا عندما لا يكون للخطوة السابقة عمل مفتوح. أوقفه لتأتي كل خطوة وفق جدولها الخاص، مع بقائها معروضة معًا كمجموعة واحدة.",
        "2": "لتغيير مجموعة لاحقًا، افتحها في تبويب «الصيانة» واضغط «تعديل الخطوات». «إضافة خطوة» تنشئ خطة جديدة تنضم إلى المجموعة كآخر خطوة فيها. و«فك ربط الخطوات» يعيد كل خطوة خطة مستقلة: لا يُحذف شيء، وتحتفظ كل خطة بجدولها. ويمكن لحزمة قطاع أيضًا إضافة مجموعة خطوات جاهزة."
      },
      "preview": {
        "screen": "المولد 1 · الصيانة",
        "rows": {
          "0": "صيانة المولد · 3 خطوات تُنفذ بالترتيب",
          "1": "الخطوة 1 · تغيير الزيت"
        },
        "highlight": "ربط الخطط كخطوات",
        "pin": "تُنفذ بالترتيب"
      }
    },
    "record-a-meter-reading": {
      "title": "سجّل قراءة عداد",
      "summary": "حافظ على مواعيد الخطط التي تعتمد على الاستخدام.",
      "whyItMatters": "الصيانة المستحقة كل 10,000 ميل لا تكون في موعدها إلا إذا عُرفت المسافة المقطوعة، وقراءة واحدة تُبقي كل خطط هذا الأصل دقيقة.",
      "timeEstimate": "دقيقة واحدة",
      "intro": "في الأصل، اختر «أرشدني ← تسجيل قراءة عداد»، أو «أضف قراءة» في قائمة +.",
      "paragraphs": {
        "0": "اكتب الرقم، أو في تطبيق الهاتف أو الجهاز اللوحي أضف صورة للعداد فيقرؤها AssetWRX على جهازك دون استهلاك أرصدة الذكاء الاصطناعي. على الويب تُحفظ الصورة كدليل وتكتب الرقم بنفسك. وتُزامن القراءات المسجلة دون اتصال عند عودتك إلى الإنترنت."
      },
      "preview": {
        "screen": "الشاحنة 7 · قراءة",
        "rows": {
          "0": "المسافة المقطوعة",
          "1": "القراءة · 36,120"
        },
        "highlight": "حفظ القراءة",
        "pin": "حافظ على استمرار العدّ"
      }
    },
    "inspection-templates": {
      "title": "قوائم التحقق",
      "summary": "أنشئ قائمة تحقق مرة واحدة وأعد استخدامها في كل فحص.",
      "whyItMatters": "الفحوصات الموحّدة تعني نتائج قابلة للمقارنة: يطرح كل مفتش الأسئلة نفسها ويوثّق الأدلة نفسها، أيًا كان من يقوم بالزيارة.",
      "timeEstimate": "قراءة لمدة 3 دقائق",
      "intro": "قوائم التحقق هي مكتبتك من قوائم التحقق القابلة لإعادة الاستخدام في الفحوصات. تجدها في «المزيد ← قوائم التحقق» على الهاتف، أو في «قوائم التحقق» بالقائمة الجانبية على الجهاز اللوحي أو الحاسوب.",
      "paragraphs": {
        "0": "أنشئ قائمة تحققًا واختر طريقة بنائه: «إنشاء بالذكاء الاصطناعي» يكتب لك مسودة قائمة تحقق، و«إنشاء يدويًا» يبدأ بقائمة فارغة. وفي الحالتين يمكنك تعديل النتيجة قبل الحفظ.",
        "1": "نظّم الفحوصات في مجموعات. لكل بند، اختر طريقة قياسه: الحالة، أو المستوى، أو نعم/لا، أو ناجح/راسب، واجعله «مطلوب»، وحدّد متى يُعدّ إخفاقًا، واذكر الدليل المطلوب توثيقه، مثل صورة.",
        "2": "ابحث، وصفِّ حسب نوع الأصل أو الفئة، وأعد استخدام قائمة تحقق من أي فحص: تقترح نافذة التخطيط قائمة التحقق المطابقة للأصل.",
        "3": "لاستخدام قائمة تحقق لبعض الأصول فقط، افتح «تفاصيل قائمة التحقق وإمكانية رؤيته» واختر أنواع الأصول الخاصة بك (مبرّد، غرفة نزلاء) أو أنواع الأماكن (غرفة، طابق). إذا تُركت فارغة، تناسب كل أصل من نوعها."
      },
      "preview": {
        "screen": "قوائم التحقق",
        "rows": {
          "0": "السلامة من الحريق الشهرية",
          "1": "جولة فحص المركبة"
        },
        "highlight": "إنشاء قائمة تحقق",
        "pin": "بالذكاء الاصطناعي أو يدويًا"
      }
    },
    "industry-packs": {
      "title": "حزم القطاعات",
      "summary": "ابدأ بقوائم تحقق مصممة لمجال عملك.",
      "whyItMatters": "يبدو يومك الأول كأسبوعك العاشر: قوائم تحقق جاهزة للعقارات أو الأسطول أو المعدات أو المرافق، بدلًا من مكتبة قوائم تحقق فارغة.",
      "timeEstimate": "دقيقتان",
      "intro": "تضيف حزم القطاعات قوائم تحقق جاهزة لقطاع واحد. افتح «الحساب ← متقدم ← حزم القطاعات»، أو «أرشدني ← إضافة حزمة قطاع».",
      "paragraphs": {
        "0": "الحزم نقاط انطلاق وليست ادعاءً بالامتثال: عدّل قوائم التحقق لتناسب طريقة عملك. عند إزالة حزمة، تبقى أي قائمة تحقق غيّرتها، وتُزال معها قوائم التحقق التي لم تغيّرها قط."
      },
      "preview": {
        "screen": "حزم القطاعات",
        "rows": {
          "0": "العقارات · 8 قوائم تحقق",
          "1": "الأسطول · 6 قوائم تحقق"
        },
        "highlight": "تثبيت الحزمة",
        "pin": "اختر مجالك"
      }
    },
    "work-list": {
      "title": "قائمة «العمل»",
      "summary": "كل طلب وفحص ومهمة في قائمة واحدة، مرتبة حسب ما يحتاج إليك.",
      "whyItMatters": "مكان واحد يجيب عن سؤال «ماذا أفعل بعد ذلك؟»: يرتفع العمل العاجل والمتأخر إلى الأعلى، أيًا كان نوعه.",
      "timeEstimate": "قراءة لمدة دقيقتين",
      "intro": "تبويب «العمل» قائمة واحدة بالطلبات والفحوصات والمهام. يُفتح على «يحتاج إليك»، مرتبًا حسب درجة الإلحاح.",
      "paragraphs": {
        "0": "تغيّر طرق العرض السريعة زاوية الرؤية: «يحتاج إليك» (المتأخر، أو العاجل، أو ما ينتظر قرارك)، و«عملي» (المُسند إليك أو ما ينتظرك)، و«يحل قريبًا»، و«مراجعة» (الأعمال والتقارير التي تنتظر المراجعة أو الاعتماد)، و«الكل».",
        "1": "تضيّق «تصفية» القائمة حسب النوع («الطلبات»، «الفحوصات»، «المهام»)، والأصل، والموقع، والمُسند إليه، ودرجة الإلحاح، والحالة، وتحدد الترتيب والتجميع. على الهاتف، يفتح زر «التقويم» («يومي» مع تخطيط العمل) التقويم الذي يعرض كل العمل المخطط.",
        "2": "تصل الطلبات الجديدة والموافقات وطلبات التغيير كلها إلى هنا، فافتح أيًا منها لتقرر. أما قوائم التحقق فلها مكتبة «قوائم التحقق» الخاصة بها.",
        "3": "شريحة النطاق في الأعلى تختار الكل أو فريقًا واحدًا. إذا كنت تعمل أيضًا مقاولًا لشركات أخرى، فاختر أعمال المقاول لرؤية تلك الأعمال وعروض الأسعار هنا. إذا كان لديك أكثر من عميل، تُجمَّع الأعمال تحت اسم كل عميل."
      },
      "preview": {
        "screen": "العمل",
        "rows": {
          "0": "الغلاية 3 · الفحص متأخر",
          "1": "المضخة 12 · بانتظار موافقتك"
        },
        "highlight": "يحتاج إليك",
        "pin": "ابدأ من هنا"
      }
    },
    "plan-a-day": {
      "title": "خطّط يومًا",
      "summary": "وزّع عمل الأسبوع على الأشخاص والأوقات، وشاهد التنقل بين المحطات، ودع «اقتراح خطة» يملأ الباقي.",
      "whyItMatters": "اليوم المخطط يراه الجميع ويمكنهم قبوله: من يذهب إلى أين، وبأي ترتيب، ومع أي قطع، ولا يُحفظ شيء حتى توافق.",
      "timeEstimate": "4 دقائق",
      "intro": "في «العمل»، يفتح زر التقويم لوحة اليوم: مسار لكل شخص، وقائمة «غير مخطط» بجانبه، والتنقل مرسوم بين المحطات. اسحب بطاقة، أو استخدم لوحة «الخطة» الخاصة بها، ثم اضغط «تطبيق».",
      "paragraphs": {
        "0": "تسرد «غير مخطط» الأعمال التي ليس لها وقت أو شخص، مع سبب لكل منها («لا طاقة استيعابية»، «القطعة غير متوفرة»، «المهارة غير متوفرة»). اضغط إحداها: تسألك لوحة «الخطة» عن الشخص واليوم والوقت، وتظهر البطاقة بإطار متقطع على اللوحة، أي مقترحة وغير محفوظة.",
        "1": "يضع «اقتراح خطة» الأعمال غير المخططة بأقل قدر من التنقل، ضمن ساعات عمل كل شخص ومهاراته، ويذكر سببًا لكل تغيير. اضغط × على أي تغيير لا تريده. يحفظ «تطبيق» الخطة، ويُبلغ كل شخص مرة واحدة، ويطلب منه قبول يومه؛ والمهمة التي تتجاوز ساعات عمله أو تتعارض مع زيارة أخرى تتطلب ذكر سبب.",
        "2": "تحتاج لوحة اليوم إلى جهاز لوحي أو كمبيوتر، وهي مخصصة للمالكين والمسؤولين. ويرى الآخرون «يومي».",
        "3": "على الهاتف، التقويم نفسه هو «يومي»: زياراتك بالترتيب مع الطريق بين كل منها، و«قبول» و«رفض»، و«الاتجاهات»، و«ابدأ التالي». ويعرض «أسبوع» مدى امتلاء أيام كل شخص وما إذا كان العمل المتوقع سيتسع."
      },
      "preview": {
        "screen": "العمل · الثلاثاء 6 أكتوبر",
        "rows": {
          "0": "سارة · 08:00 المضخة 12 · استبدال مانع التسرب",
          "1": "أحمد · 10:00 وحدة التكييف 08 · تغيير الفلتر",
          "2": "غير مخطط · 9"
        },
        "highlight": "اقتراح خطة",
        "pin": "املأ اليوم"
      }
    },
    "my-day": {
      "title": "يومك («يومي»)",
      "summary": "شاهد زياراتك لهذا اليوم بالترتيب، وابدأ الزيارة التالية.",
      "whyItMatters": "اعرف وجهتك التالية دون أن تسأل: زياراتك بالترتيب، مع مسافة القيادة بينها.",
      "timeEstimate": "دقيقتان",
      "intro": "افتح «العمل» واضغط «يومي». تظهر زياراتك لهذا اليوم بالترتيب، مع مسافة القيادة بين كل منها.",
      "paragraphs": {
        "0": "اضغط «قبول» لتأكيد يومك، و«الاتجاهات» للوصول، و«ابدأ التالي» لفتح المهمة التالية.",
        "1": "إذا كانت مساحة عملك تستخدمها، تتيح «مشاركة الموقع» لمخطط العمل معرفة متى تتأخر. وهي تعمل فقط أثناء فتح التطبيق، وتتوقف في نهاية اليوم."
      },
      "preview": {
        "screen": "يومي · الثلاثاء 6 أكتوبر",
        "rows": {
          "0": "08:00 المضخة 12 · استبدال مانع التسرب",
          "1": "10:00 وحدة التكييف 08 · تغيير الفلتر"
        },
        "highlight": "ابدأ التالي",
        "pin": "ابدأ الزيارة التالية"
      }
    },
    "create-a-job": {
      "title": "أنشئ مهمة",
      "summary": "كلّف بعمل على أصل ببضع ضغطات.",
      "whyItMatters": "كل إصلاح متتبَّع ومحسوبة تكلفته ومرتبط بأصله، فلا ضياع للأعمال في صناديق البريد أو جداول البيانات بعد الآن.",
      "timeEstimate": "3 دقائق",
      "intro": "المهمة عمل يُنفّذ على أصل. اختر «أضف مهمة» من قائمة + في الأصل، وصِفها، فتظهر في «العمل» وفي سجل الأصل.",
      "preview": {
        "screen": "مهمة · المضخة 12",
        "rows": {
          "0": "العنوان · استبدال مانع التسرب",
          "1": "متى · الآن"
        },
        "highlight": "إنشاء مهمة",
        "pin": "كلّف بها"
      }
    },
    "assign-a-job": {
      "title": "أسند مهمة",
      "summary": "سلّم العمل لفريقك، أو لمقاول، أو اطلب عروض أسعار.",
      "whyItMatters": "أوصل العمل إلى الأيدي المناسبة بسرعة، سواء فريقك أو مقاول مباشر أو عروض أسعار تنافسية، دون مغادرة المهمة.",
      "timeEstimate": "دقيقتان",
      "intro": "تحت «من سينفذها؟» اختر «فريقنا» أو «مقاول» أو «طلب عروض أسعار». ثم اضغط «تكليف» في المهمة واختر الشخص أو الشركة. يحتاج المقاول إلى بريد إلكتروني ليصله الإشعار.",
      "paragraphs": {
        "0": "يعرض أمر العمل المستحق اليوم والمسند إليك قبول وبدء أو قبول وجدولة. الإكمال صفحة واحدة: ملاحظة أو شريحة، وصور، ثم إرسال. إذا احتاج الأمر إلى تكاليف أو قراءة عداد أو فحص، يصبح الزر متابعة.",
        "1": "يمكن أن يضم العمل الكبير أعمالًا فرعية: أجزاء لكل منها شخص أو مقاول وتاريخ، تُفحص واحدًا تلو الآخر وتُعتمد مرة واحدة ككل. راجع الأعمال ذات الأعمال الفرعية. أما العمل الذي ينفذه الشخص نفسه على عدة أيام فهو زيارات لا أعمال فرعية: راجع الزيارات."
      },
      "preview": {
        "screen": "مهمة · المضخة 12",
        "rows": {
          "0": "من سينفذها؟ · مقاول",
          "1": "مُسند إلى · لا أحد بعد"
        },
        "highlight": "تكليف",
        "pin": "اختر من سينفذها"
      }
    },
    "jobs-with-sub-jobs": {
      "title": "الأعمال ذات الأعمال الفرعية",
      "summary": "قسّم العمل الكبير إلى أجزاء لكل منها شخص وتاريخ؛ افحص كل جزء واعتمد العمل مرة واحدة.",
      "whyItMatters": "تجديد مطبخ أو تحديث غرفة معدات يعني عدة حِرف على عدة أيام. تبقيها الأعمال الفرعية تحت عمل واحد: ترى ما تبقى ومن تأخر وكم يكلف، ويعتمد العميل مرة واحدة.",
      "timeEstimate": "قراءة 5 دقائق",
      "intro": "في العمل، تحت الأعمال الفرعية، اضغط إضافة عمل فرعي. في المرة الأولى حدّد من يدير العمل: أنت أو زميل أو مقاول رئيسي. كل عمل فرعي عمل عادي له شخص أو مقاول وتاريخ وفحوصات وصور وتكاليف وتقرير خاص به.",
      "paragraphs": {
        "0": "يعرض العمل حالته مرة واحدة، محسوبة من أعماله الفرعية: بانتظار، مجدول، قيد التنفيذ، يحتاجك، جاهز للاعتماد أو معتمد. تخبرك بطاقة الخطوة التالية بما يجب فعله الآن. يظهر كل عمل فرعي في القائمة مع الشخص والتاريخ وما ينتظره؛ وعلى الجهاز اللوحي أو الحاسوب يعرضها خط زمني حسب التاريخ مع اليوم والنهاية المتوقعة.",
        "1": "فعّل نفّذها بالترتيب ليجعل كل عمل فرعي ينتظر الذي قبله، أو افتح قائمة عمل فرعي واختر ينتظر لتحدد ما ينتظره بالضبط. لا يبدأ العمل الفرعي المنتظِر حتى يُنجز ما ينتظره ويُفحص.",
        "2": "عند انتهاء عمل فرعي يفحصه مسؤول العمل (أو الفاحص المحدد)، أو يعيده، أو يطلب صورًا إضافية. وعند فحص كل الأعمال الفرعية يعتمد المعتمِد العمل كله مرة واحدة. العمل المرتبط بطلب يؤكده مقدم الطلب مرة واحدة للعمل كله.",
        "3": "العمل الإضافي المكتشف أثناء عمل فرعي ينتظر قرارًا قبل اعتماد العمل: إضافة إلى هذا العمل تجعله العمل الفرعي التالي؛ عمل منفصل يبقيه مستقلًا.",
        "4": "تضم القائمة (…) في الأعمال الفرعية: نقل كل التواريخ، تحديد ميزانية، الحفظ كقالب، استخدام قالب، تسليم العمل لمقاول رئيسي، وإلغاء العمل كله. يحفظ القالب الخطوات وترتيبها وما ينتظر ماذا؛ ولا يحفظ الأشخاص أو التواريخ أبدًا.",
        "5": "يمكن لمقاول رئيسي إدارة العمل نيابة عنك: يضيف أعمالًا فرعية لفريقه، أو لمقاوليك إن سمحت، ويفحص كل جزء، وتعتمد أنت في النهاية. استعد العمل في أي وقت من القائمة نفسها.",
        "6": "في صفحة العمل تُطوى الأعمال الفرعية تحت عملها؛ وعلى اللوحة يبقى كل منها بطاقة. من عمل فرعي، يعيدك زر الرجوع إلى عمله. يسرد تقرير العمل كل عمل فرعي (ملخص أو كامل، داخلي أو للعميل). يحسب Asset 360 وSite 360 العمل ذا الأعمال الفرعية مرة واحدة.",
        "7": "في Power BI يحتوي جدول Jobs على SubJobOf وFamilyStatus وSubJobsTotal وSubJobsDone وSubJobsLate وCountsOnce. لعدّ كل عمل مرة واحدة استخدم مقياسًا مثل Jobs counted once = CALCULATE(COUNTROWS(Jobs), Jobs[CountsOnce] = TRUE()). تسرد الواجهة البرمجية الأعمال الفرعية لعمل في ‎/v1/jobs/{id}/sub-jobs، وتُعلمك الويب هوكس عند إضافة عمل فرعي أو تغيّر حالة العمل.",
        "8": "يخبرك المساعد بما تبقى في العمل ومن تأخر والنهاية المتوقعة، وينقل عملًا فرعيًا وما بعده عدة أيام (تؤكد أنت ويمكنك التراجع). الأعمال الفرعية مفتاح في خطتك؛ وإيقافه يُبقي كل الأعمال الفرعية المنشأة."
      },
      "preview": {
        "screen": "عمل · تجديد المطبخ",
        "rows": {
          "0": "الأعمال الفرعية · 2 من 5 منجزة",
          "1": "1. الإزالة · لي · منجز",
          "2": "2. التمديدات الكهربائية الأولى · Spark Ltd · اليوم"
        },
        "highlight": "إضافة عمل فرعي",
        "pin": "عمل واحد، أجزاء كثيرة"
      }
    },
    "visits": {
      "title": "الزيارات: عمل واحد على عدة أيام",
      "summary": "يعود الشخص نفسه في يوم آخر. خطّط لكل زيارة؛ وأكمل العمل مرة واحدة في النهاية.",
      "whyItMatters": "المرحلة الأولى يوم الاثنين والثانية يوم الخميس عمل واحد لا عملان. تبقيه الزيارات في العمل والتقويم في كل يوم دون إغلاقه وإعادة فتحه.",
      "timeEstimate": "دقيقتان",
      "intro": "في العمل، تحت الزيارات، اضغط تخطيط زيارة واختر اليوم والوقت. تظهر كل زيارة في العمل والتقويم في يومها. في اليوم المحدد اضغط وصلت؛ أضف ملاحظات وصورًا لتلك الزيارة؛ وأكمل العمل عند انتهاء آخر زيارة.",
      "paragraphs": {
        "0": "القاعدة: الشخص نفسه في أيام متعددة يعني زيارات. أما شخص أو حرفة أو عرض سعر أو فحص مختلف فهو عمل فرعي.",
        "1": "إن لم تستطع الإنهاء اليوم، افتح لا يمكن الإكمال كما هو مجدول واختر أحتاج إلى العودة. اذكر السبب وما أُنجز واختر الزيارة التالية. تنتهي زيارة اليوم ويُخطط للتالية ويبقى العمل مفتوحًا ومتوقفًا مؤقتًا حتى ذلك الحين. لا يحتاج أحد للموافقة.",
        "2": "يتبع تاريخ العمل دائمًا زيارته التالية، فتستمر التذكيرات والتخطيط بالعمل. يمكن نقل زيارة لم تبدأ أو إلغاؤها من قائمتها. إكمال العمل أو إلغاؤه يغلق زياراته المفتوحة.",
        "3": "تعطي الواجهة البرمجية لكل عمل visitsTotal وnextVisits."
      },
      "preview": {
        "screen": "عمل · استبدال الغلاية",
        "rows": {
          "0": "الزيارة 1 · الاثنين 9:00 · تمت",
          "1": "الزيارة 2 · الخميس 9:00 · مخططة"
        },
        "highlight": "تخطيط زيارة أخرى",
        "pin": "الشخص نفسه، يوم آخر"
      }
    },
    "prove-a-job-is-done": {
      "title": "أثبت أن المهمة أُنجزت (WRX Verified)",
      "summary": "قدّم الصور والقراءات التي تطلبها المهمة، واحصل على التحقق منها.",
      "whyItMatters": "زيارات عودة أقل: يرى منفّذ المهمة بالضبط الإثبات المطلوب، ويرى المراجع ما تُظهره الصور.",
      "timeEstimate": "قراءة لمدة 3 دقائق",
      "intro": "افتح المهمة وانظر إلى «ما يحتاجه هذا العمل». يذكر كل صف ما يجب تقديمه، مثل صورة أو قراءة، مع زر لإضافته.",
      "paragraphs": {
        "0": "عندما تقدّم كل شيء، اضغط «إكمال». يفحص AssetWRX الصور ويُبلغ المراجع بما تُظهره.",
        "1": "ثم يضغط المراجع «اعتماد» أو «إعادة للتعديل» أو «طلب صور». والمراجع وحده يمكنه اعتماد المهمة.",
        "2": "من أنشأ المهمة يقرر الإثبات المطلوب لها، ويحدده من «إدارة» في المهمة."
      },
      "preview": {
        "screen": "مهمة · استبدال الصمام",
        "rows": {
          "0": "صورة الصمام الجديد",
          "1": "قراءة الضغط"
        },
        "highlight": "ما يحتاجه هذا العمل",
        "pin": "أضف كل بند"
      }
    },
    "cant-complete-as-scheduled": {
      "title": "عندما لا يمكن تنفيذ العمل",
      "summary": "اطلب نقل العمل المجدول أو إعادة إسناده أو تخطيه، مع ذكر السبب.",
      "whyItMatters": "يُبلَّغ عن العمل المتعثر بصدق بدلًا من أن يتأخر بصمت، ويتخذ المدير قراره والسبب والأدلة أمامه.",
      "timeEstimate": "قراءة لمدة دقيقتين",
      "intro": "في مهمة مجدولة لا يمكنك تنفيذها كما خُطط لها، اختر «لا يمكن الإكمال كما هو مُجدوَل». اختر ما أوقفك، مثل عدم وجود وصول، أو عدم أمان المتابعة، أو عدم توفر القطع، وما تحتاج إليه.",
      "paragraphs": {
        "0": "اطلب «نقله» (العمل نفسه في تاريخ لاحق)، أو إعطاءه لـ«شخص آخر»، أو «تخطي هذه». أضف التفاصيل، ويُفضل إرفاق صورة، فهي تجعل الموافقة على الطلب أسهل كثيرًا.",
        "1": "يذهب النقل أو إعادة الإسناد إلى مديرك كطلب تغيير؛ لا يتغير شيء حتى يوافق عليه أو يرفضه أو يعدّله ويوافق عليه، ويبقى العمل مستحقًا في الأثناء.",
        "2": "حيث تسمح الخطة، يُطبَّق التخطي فورًا. يُسجَّل الموعد المتخطى على أنه متخطى ويحتفظ بمكانه في الجدول، ويبقى الموعد التالي مستحقًا في وقته."
      },
      "preview": {
        "screen": "لا يمكن الإكمال كما هو مُجدوَل",
        "rows": {
          "0": "ما الذي أوقفك؟ · لا يوجد وصول",
          "1": "إضافة تفاصيل · البوابة مقفلة"
        },
        "highlight": "إرسال الطلب",
        "pin": "مديرك يقرر"
      }
    },
    "report-an-issue": {
      "title": "أبلغ عن مشكلة",
      "summary": "سجّل المشكلة مرة واحدة واختر ما يجب أن يحدث.",
      "whyItMatters": "بلاغ واحد، ونتيجة صحيحة، ومكان واحد لمتابعته، فلا يضيع شيء بين «تم الإبلاغ» و«تم الإصلاح».",
      "timeEstimate": "دقيقتان",
      "intro": "افتح الأصل، واضغط +، ثم «الإبلاغ عن مشكلة». حدّد ما تحتاج إليه: «فقط مساعدة — لست متأكدًا بعد»، أو «طلب مهمة»، أو «طلب تفتيش»، وأضف ملخصًا قصيرًا، واضغط «إرسال». سيراجعه أحد الأشخاص في «العمل» ويحوّله إلى عمل.",
      "paragraphs": {
        "0": "أملِ التفاصيل واستخدم «تحسين بالذكاء الاصطناعي» لترتيبها قبل الإرسال."
      },
      "preview": {
        "screen": "الإبلاغ عن مشكلة",
        "rows": {
          "0": "الأصل · المضخة 12",
          "1": "ملخص قصير · تسرب من مانع التسرب"
        },
        "highlight": "ماذا تحتاج؟",
        "pin": "اختر النتيجة"
      }
    },
    "convert-a-request": {
      "title": "حوّل طلبًا إلى عمل",
      "summary": "وافق على طلب وحوّله إلى مهمة أو فحص.",
      "whyItMatters": "يتحول البلاغ إلى عمل مخطط بضغطة واحدة، مع نقل السجل الكامل، فيرافق «السبب» العمل دائمًا.",
      "timeEstimate": "دقيقتان",
      "intro": "افتح الطلب من «العمل» واضغط «الموافقة». ثم اضغط «إنشاء العمل» أو «فحص»: تُملأ تفاصيل الطلب تلقائيًا، وتختار أنت من ينفذ العمل ومتى. ويبقى كل شيء مرتبطًا بالطلب.",
      "preview": {
        "screen": "طلب · المضخة 12",
        "rows": {
          "0": "أبلغ عنه · المستأجر",
          "1": "النتيجة · طلب مهمة"
        },
        "highlight": "إنشاء العمل",
        "pin": "موافقة ← عمل"
      }
    },
    "share-for-requests": {
      "title": "شارك أصلًا",
      "summary": "امنح جهة اتصال وصولًا مضبوطًا إلى أصل.",
      "whyItMatters": "شارك السياق التشغيلي المناسب دون منح كل جهة اتصال الصلاحيات نفسها.",
      "timeEstimate": "دقيقتان",
      "intro": "في الأصل اضغط + ثم «مشاركة»، واختر جهة اتصال، ثم راجع صلاحية وصولها: «يمكنه العرض» (للقراءة فقط) أو «يمكنه الطلب»، الذي يتيح لها أيضًا الإبلاغ عن المشكلات ومتابعة طلباتها. البلاغات العامة عبر رمز QR خيار منفصل.",
      "preview": {
        "screen": "المضخة 12 · مشاركة",
        "rows": {
          "0": "جهة الاتصال · خالد أحمد"
        },
        "highlight": "الوصول · يمكنه العرض",
        "pin": "راجع الوصول"
      }
    },
    "public-intake-qr": {
      "title": "البلاغات العامة عبر رمز QR",
      "summary": "دع أي شخص يبلّغ عن مشكلة بمسح رمز.",
      "whyItMatters": "رمز QR على الأصل يحوّل أي شخص قريب إلى نظام إنذار مبكر لديك، وتصل البلاغات والأصل محدد مسبقًا.",
      "timeEstimate": "3 دقائق",
      "intro": "تتيح البلاغات العامة لأي شخص لديه رمز QR الإبلاغ عن مشكلة في أصل، دون تطبيق أو حساب أو تسجيل دخول. وتصل بلاغاتهم كطلبات في «العمل».",
      "paragraphs": {
        "0": "من يمسح الرمز دون تسجيل الدخول يرى \"الإبلاغ عن مشكلة\" فقط ما دام الاستقبال العام مفعّلًا. وإذا كان متوقفًا، تعرض الصفحة \"قم بتسجيل الدخول للمشاهدة\"."
      },
      "preview": {
        "screen": "المضخة 12 · البلاغات العامة",
        "rows": {
          "0": "البلاغات العامة · مفعّلة",
          "1": "رمز QR للبلاغات العامة"
        },
        "highlight": "انسخ الرابط",
        "pin": "شاركه أو اطبعه"
      }
    },
    "add-a-contractor": {
      "title": "أضف مقاولًا",
      "summary": "أضف مقاولًا خارجيًا يمكنك إسناد العمل إليه.",
      "whyItMatters": "أرسل العمل إلى شركات خارجية وتابعه في المكان نفسه مع عمل فريقك. ولا يرون إلا ما ترسله إليهم.",
      "timeEstimate": "دقيقتان",
      "intro": "المقاول جهة اتصال لها دور «مقاول». ولا يمكن إسناد المهام أو توجيه دعوات تقديم عروض الأسعار إلا لجهات الاتصال التي لها هذا الدور.",
      "paragraphs": {
        "0": "تحت «الأدوار»، حدّد «مقاول» قبل الضغط على «إضافة جهة اتصال»."
      },
      "preview": {
        "screen": "جهة اتصال جديدة",
        "rows": {
          "0": "الاسم · شركة الأمل للصيانة",
          "1": "البريد الإلكتروني · ops@alamal.co"
        },
        "highlight": "الأدوار · مقاول",
        "pin": "اجعله قابلًا للإسناد"
      }
    },
    "quotes-overview": {
      "title": "الحصول على عروض الأسعار",
      "summary": "اطلب عروض الأسعار وقارن بينها قبل ترسية العمل.",
      "whyItMatters": "قارن بين عروض متكافئة ورسِّ العمل بثقة، دون كشف أسعار مقاول لآخر أو كشف مساحة عملك الأوسع.",
      "timeEstimate": "قراءة لمدة 3 دقائق",
      "intro": "عندما لا تكون تكلفة المهمة ثابتة، اختر «طلب عروض أسعار» تحت «من سينفذها؟»، وادعُ المقاولين لتسعيرها، ثم امنح العقد لمن تختاره.",
      "paragraphs": {
        "0": "يدعو «طلب عروض أسعار» مقاولين من جهات اتصالك، فهو ليس إعلانًا عامًا. صِف العمل (يمكن للذكاء الاصطناعي كتابة مسودة)، ويمكنك إن شئت تحديد موعد نهائي للرد وتواريخ مستهدفة وميزانية.",
        "1": "قارن العروض جنبًا إلى جنب، ثم اضغط «منح العقد» على العرض الذي تختاره. تُسند المهمة إلى ذلك المقاول بالسعر والمدة اللذين قدّمهما، ويُبلَّغ الآخرون بأنه لم يقع عليهم الاختيار.",
        "2": "إذا رفض المقاول الذي اخترته المهمة بعد ذلك، تُفتح المقارنة من جديد وتعود إليها عروض الأسعار الأخرى، لتتمكن من منحها لشخص آخر.",
        "3": "لا يرى المقاول إلا ما يحتاج إليه لتسعير العمل، ولا يرى أبدًا أسعار مقاول آخر أو مساحة عملك الأوسع."
      }
    },
    "contractor-experience": {
      "title": "ما يراه مقاولوك",
      "summary": "واجهة المقاول الخاصة: الدعوات، ومهامه، ولا شيء غير ذلك.",
      "whyItMatters": "يعمل المقاولون في AssetWRX بمصطلحاتهم: تسعير، وقبول، وتحديث، وتسليم، بينما تبقى ملاحظاتك الداخلية وأسعار المقاولين الآخرين خاصة.",
      "timeEstimate": "قراءة لمدة دقيقتين",
      "intro": "المقاول الذي يسجّل الدخول بالبريد الإلكتروني الذي أضفته به لا يرى إلا العمل الذي ترسله إليه.",
      "paragraphs": {
        "0": "تعرض صفحته الرئيسية دعوات لتقديم عروض أسعار أو تولّي أعمال. ويصبح تبويب «العمل» لديه «أعمالي»، وهو مسار من مراحل: «جديد»، و«قادم»، و«قيد التنفيذ»، و«بانتظار المراجعة»، و«مكتمل».",
        "1": "في المهمة يمكنه إرسال سعر أو الاعتذار، وقبول العمل، ونشر التحديثات والصور، وتسليمه على أنه مكتمل. ويبقى في «بانتظار المراجعة» حتى تتحقق منه أو تعيده للتعديل.",
        "2": "لا يرى أبدًا الملاحظات الداخلية لفريقك، إذ يعلّمها محرر التحديثات بعبارة «ملاحظة داخلية — لن يراها المقاول»، ولا أسعار مقاول آخر."
      }
    },
    "sign-off-an-inspection": {
      "title": "اعتمد فحصًا أو أعده للتعديل",
      "summary": "راجع الفحص المكتمل، ثم اعتمده أو أعده مع ذكر السبب.",
      "whyItMatters": "لا يُعتمد شيء عن طريق الخطأ: عين ثانية توافق على العمل، أو تعيده مع توضيح ما يجب إصلاحه بالضبط.",
      "timeEstimate": "دقيقتان",
      "intro": "افتح الفحص المكتمل. في «موافقة»، اضغط «اعتماد»، أو اضغط «إعادة للتعديل» واذكر ما يحتاج إلى إصلاح.",
      "paragraphs": {
        "0": "يصل سببك إلى المفتش، ويُفتح الفحص له من جديد مع ملاحظتك في الأعلى. وعندما يكمله مرة أخرى، يعود إليك.",
        "1": "لا يمكن الاعتماد إلا لمالك الأصل أو المعتمِد المعيّن له أو فريقه، ولا يمكن للمفتش أبدًا اعتماد عمله بنفسه.",
        "2": "يمكنك أيضًا الاعتماد من التقرير: يرى من يعتمده «اعتماد» و«إرجاع» أعلى التقرير. ويرى مراجع المهمة «اعتماد» و«إرجاع» و«طلب صور» أعلى تقرير إكمال المهمة."
      },
      "preview": {
        "screen": "الفحص · الغلاية 3",
        "rows": {
          "0": "مكتمل · بانتظار الاعتماد",
          "1": "موافقة"
        },
        "highlight": "إعادة للتعديل",
        "pin": "أو «اعتماد»"
      }
    },
    "share-a-report": {
      "title": "شارك تقريرًا",
      "summary": "أرسل تقرير الفحص إلى جهة الاتصال المناسبة.",
      "whyItMatters": "أغلق الحلقة: يرى الشخص المعني النتيجة موثقة، وهذا ما يحوّل التقرير إلى ثقة.",
      "timeEstimate": "دقيقتان",
      "intro": "بعد الفحص، اختر «مشاركة التقرير». اختر جهة الاتصال، وحدّد علاقتها بالعمل، مثل مقدّم الطلب الذي رفعه، ثم أرسله. المشاركة تغلق الحلقة على الطلب.",
      "paragraphs": {
        "0": "إذا فتح الرابط شخص ليس هو من أُرسل إليه، يمكنه النقر على \"طلب الوصول\". يظهر الطلب أعلى العمل (\"يحتاج إليك\" و\"مراجعة\") وأعلى التقرير. انقر على \"الموافقة\" للسماح له بقراءة هذا التقرير وحده، أو \"رفض\".",
        "1": "لا يمكن فتحه إلا للشخص الذي ترسله إليه: الرابط في بريده يسجّل دخوله مباشرة. تبدأ الإصلاحات المقترحة موافقًا عليها؛ فيضغط «رفض» على ما لا يريده، ثم يوقّع، وزر شاشة التوقيع هو «اعتماد». وتُشارك تقارير المهام وتقارير Asset 360 بالشاشة والكلمات نفسها."
      },
      "preview": {
        "screen": "مشاركة التقرير",
        "rows": {
          "0": "التقرير · السلامة الشهرية",
          "1": "إلى · خالد أحمد"
        },
        "highlight": "إرسال",
        "pin": "أغلق الحلقة"
      }
    },
    "ai-insight-reports": {
      "title": "تقارير Asset 360 وSite 360",
      "summary": "تقرير واحد عن أصل أو موقع، مكتوب للشخص الذي سيقرؤه.",
      "whyItMatters": "حوّل السجلات المتفرقة إلى تقرير جاهز لاتخاذ القرار، بحكم واضح وخطة عمل، يُروى كما يحتاجه المؤجر أو العميل أو المستثمر أو مدير الموقع.",
      "timeEstimate": "3 دقائق",
      "intro": "افتح الأصل، واضغط +، ثم «Asset 360». في الموقع، اضغط + ثم «Site 360». يُفتح التقرير فورًا بأرقام التطبيق نفسه: الحكم، وبطاقة الأداء، وكل موضوع مع مخططه، وما يجب فعله بعد ذلك.",
      "paragraphs": {
        "0": "اختر لمن هو: مدير الأصول أو العميل أو المؤجر أو مدير الموقع أو المستثمر. يحصل كل قارئ على الحقائق نفسها، بالترتيب الذي يهمه. تُخفي نسختا المؤجر والمستثمر أسماء المقاولين ما لم توقف ذلك.",
        "1": "لكتابته بالذكاء الاصطناعي، اختر اللغة والمواضيع، ثم اضغط «كتابة نسخة الذكاء الاصطناعي». ينتظر في قائمة قصيرة وتُبلَّغ عندما يصبح جاهزًا. لا يُستهلك الرصيد إلا بعد كتابته؛ وإذا فشل فلا يُحتسب شيء.",
        "2": "تُظهر درجة جودة البيانات مدى اكتمال الصورة، ويوضح «احصل على المزيد» ما يجب تسجيله ليكون التقرير التالي أقوى.",
        "3": "لكل إجراء في الخطة زر لإنشاء المهمة أو الفحص الذي ينفذه.",
        "4": "يحفظ قسم «الإصدارات» كل إصدار كما كان تمامًا: اضغط «حفظ هذا الإصدار» (مجانًا) أو اطلب نسخة الذكاء الاصطناعي، ثم افتح أي إصدار لقراءته أو مقارنته بالسابق.",
        "5": "اضغط «مشاركة» لإرسال إصدار إلى مؤجر أو عميل أو أي شخص آخر، مثل تقرير الفحص. يُبلَّغ بالبريد الإلكتروني وفي التطبيق، ويرى الغلاف وبطاقة الأداء فورًا، ثم يسجّل الدخول أو ينشئ حسابًا مجانيًا لقراءة الباقي. يمكنك أن ترى متى قرأه، وأن ترسل إليه إصدارًا أحدث، أو تسحب المشاركة.",
        "6": "«تنزيل PDF» و«تنزيل CSV» متاحان فقط لمن يعتمد الأعمال على الأصل (وفي الموقع، على أي من أصوله).",
        "7": "تضع «المقارنة» كل درجة مقابل الأصول المماثلة التي يمكنك رؤيتها (نوع الأصل نفسه) أو مواقعك الأخرى، وفق أرقام الليلة الماضية: أفضل من معظمها، أو مثلها تقريبًا، أو خلف معظمها.",
        "8": "تعرض «القيمة والعمر» تاريخ تركيبه ومدة عمره المتوقعة وكلفته وكلفة استبداله وما كلفته أعماله، بمجرد تسجيلها (تعديل الأصل، القيمة والعمر). وعندما يتجاوز عمره المتوقع، أو تكلف إصلاحات سنة نصف ثمن الجديد، تقترح الخطة التخطيط للاستبدال. ومع تشغيل «البحث على الإنترنت»، يمكن لنسخة الذكاء الاصطناعي إضافة سعر سوق معتاد من مصادر على الإنترنت، موسوم بأنه غير متحقق منه.",
        "9": "اسأل المساعد عن حال أصل أو كيف يقارَن، فيجيب من التقرير نفسه؛ واطلب تقريرًا لمالك العقار فيفتح لذلك القارئ. ويمكن للمطورين قراءة التقرير وإصداراته عبر واجهة البرمجة واتصال وكلاء الذكاء الاصطناعي (MCP) وتغذية Power BI.",
        "10": "يمكن للمسؤول تشغيل Asset 360 وSite 360 أو إيقافهما لكل إصدار. عند الإيقاف، يفتح الزر صفحة الترقية."
      },
      "preview": {
        "screen": "مضخة 12 · Asset 360",
        "rows": {
          "0": "الحكم",
          "1": "بطاقة الأداء",
          "2": "خطة العمل"
        },
        "highlight": "كتابة نسخة الذكاء الاصطناعي",
        "pin": "للقارئ الذي تختاره"
      }
    },
    "esg": {
      "title": "الحوكمة البيئية والاجتماعية والاستدامة (ESG)",
      "summary": "الطاقة والكربون وغاز التبريد (الغازات المفلورة) وشهادات الطاقة لكل أصل وموقع ولمساحة العمل كلها.",
      "whyItMatters": "أجب المالك أو المستثمر أو المدقق بأرقام حقيقية، والتزم بفحوص تسرب الغازات المفلورة، ولا تدع شهادة طاقة تنتهي دون أن تعلم.",
      "timeEstimate": "3 دقائق",
      "intro": "افتح أصلًا أو موقعًا واضغط تبويب ESG. يقرأ قراءات العدادات التي تسجلها بالفعل ويحولها إلى الطاقة والكربون والمياه لآخر 12 شهرًا.",
      "paragraphs": {
        "0": "تأتي الطاقة من العدّادات على الأصل (الكهرباء أو الغاز أو النفط أو الحرارة أو الماء). يعرض كل رقم رئيسي التغيّر عن العام السابق، ويعرض الرسم كل شهر مقابل الشهر نفسه في العام الماضي (اضغط على عمود لترى قيمته)، ويقسّم قسم من أين يأتي الكربون الكربونَ حسب المصدر. الكربون تقدير بمعاملات التحويل الحكومية البريطانية لذلك العام: النطاق 1 هو الوقود المحروق في الموقع وتسرّب غاز التبريد، والنطاق 2 هو الكهرباء المشتراة. أدخل مساحة الموقع في تعديل الموقع لترى الطاقة لكل م². تُحدَّث الأرقام ليلًا، أو فورًا عبر تحديث.",
        "1": "غاز التبريد: يأتي الغاز من تفاصيل الأصل، فسجّل الشحنة على أصل تبريد أو مضخة حرارية. يحسب التطبيق أطنان CO2e وعدد مرات فحص التسرّب التي يتطلبها القانون (كل 12 أو 6 أو 3 أشهر، وأطول مع كشف التسرّب) ويخطّط الفحص كخطة صيانة تذكّرك كغيرها. تعرض لوحة فحوص التسرّب الفئة وآخر نتيجة وفتح المهمة، ويسرد سجل التسرّب كل فحص وتسرّب وإعادة تعبئة وغاز مسترد. في الموقع، يُنشئ حجز فحص تسرّب المهمة.",
        "2": "تُحفظ شهادات الطاقة مرة واحدة ضمن المستندات: أضف شهادة EPC أو DEC كمستند فيقرأ الذكاء الاصطناعي منها التصنيف والدرجة والمرجع والتواريخ، ومدة الصلاحية الافتراضية 10 سنوات لشهادة EPC وسنة واحدة لشهادة DEC. توضع شهادة المبنى كله في تبويب المستندات الخاص بالموقع. يعرضها تبويب ESG مع فتح الشهادة وتعديل. يُذكَّر المسؤولون قبل انتهائها، ويُعلَّم المبنى المؤجَّر المصنّف F أو G لأنه دون الحد الأدنى للتأجير.",
        "3": "اكتبه: اختر المدير أو المالك أو المستثمر وسيكتب الذكاء الاصطناعي ملخصًا قصيرًا يستخدم هذه الأرقام فقط. لكل اقتراح زر لإنشاء العمل أو الفحص أو القراءة المطلوبة.",
        "4": "تعرض الرؤى ESG للمحفظة كلها، موقعًا بموقع. وتضم تقارير Asset 360 وSite 360 فصلًا عن ESG، ويجيب المساعد عن أسئلة ESG، ويمكن للمطورين قراءتها عبر واجهة البرمجة وPower BI واتصال وكيل الذكاء الاصطناعي (MCP).",
        "5": "تضيف حزمة قطاع إدارة المرافق قائمتي تحقق، جولة طاقة وفحص تسرب الغازات المفلورة، ومتطلب شهادة طاقة في سجل الامتثال.",
        "6": "ESG إضافة مع تجربة مجانية. يفعّلها المسؤول لمساحة العمل ويمكنه تضمين كل الأصول أو مواقع مختارة فقط. في تطبيقات الهاتف، غير متاحة للشراء في التطبيق."
      },
      "preview": {
        "screen": "المقر الرئيسي · ESG",
        "rows": {
          "0": "الطاقة 120,000 كيلوواط ساعة (+20%)",
          "1": "الكربون 25 طن CO2e",
          "2": "شهادة F · أقل من حد التأجير"
        },
        "highlight": "اكتبه",
        "pin": "من قراءاتك أنت"
      }
    },
    "insights-overview": {
      "title": "الرؤى",
      "summary": "الاتجاهات والمخاطر والأداء عبر كل ما تتولى رعايته.",
      "whyItMatters": "اعرف ما يتدهور، وأين تتأخر الصيانة، ومن يحمل عبئًا زائدًا، قبل أن يتحول ذلك إلى عطل أو تدقيق فائت.",
      "timeEstimate": "قراءة لمدة دقيقتين",
      "intro": "يحوّل تبويب «الرؤى» سجلاتك إلى قرارات. بدّل بين عروض «تقني» و«مدير» و«التنفيذي» حسب السؤال الذي تطرحه.",
      "paragraphs": {
        "0": "يجيب كل قسم عن سؤال واحد: الأرقام الرئيسية، و«الحالة» (أي الأصول تزداد سوءًا)، و«الصيانة» (أين تتأخر)، و«التوقعات» (ما القادم)، و«المخاطر»، وعبء العمل وأداء المقاولين، والشهادات التي تنتهي خلال الأيام الـ90 القادمة. اضغط «عرض التفاصيل» على رقم لترى القائمة التي وراءه.",
        "1": "يعرض «سير العمل» كيف تتحرك الطلبات والفحوصات والمهام، وأين تتعثر، وكم تستغرق.",
        "2": "يحوّل «كتابة ملخص بالذكاء الاصطناعي» الصفحة إلى بضع جمل. وهو يستهلك أرصدة الذكاء الاصطناعي، وتظهر التكلفة قبل أن تبدأ.",
        "3": "تقرأ «الرؤى» بياناتك الحالية، فتزداد دقة كلما امتلأت سجلات أصولك وفحوصاتك ومهامك. وهي متاحة في الخطط التي تتضمن التحليلات."
      }
    },
    "compliance-register": {
      "title": "سجل الامتثال",
      "summary": "كل متطلب في مساحة عملك، وما يجب فعله بشأنه.",
      "whyItMatters": "أجب عن سؤال «هل نحن ملتزمون؟» لمساحة العمل كلها في قائمة واحدة، وعالج أي نقص من الصف نفسه.",
      "timeEstimate": "قراءة لمدة دقيقتين",
      "intro": "يسرد «الامتثال» كل متطلب يجب على أصولك إثباته، مع حالته: «ملتزم»، أو «قارب على الانتهاء»، أو «متأخر»، أو «الدليل مفقود»، أو «غير معروف».",
      "paragraphs": {
        "0": "افتحه من «المزيد ← الامتثال» على الهاتف، أو من «الامتثال» في القائمة الجانبية على الجهاز اللوحي أو الويب، أو من «عرض الامتثال» في بطاقة «الامتثال» في الأصل. وهو يغطي مساحة عمل، لذا انتقل من «شخصي» لتراه.",
        "1": "يذكر كل صف المسؤول ويعرض الخطوة التالية: «إضافة دليل»، أو «تجديد»، أو «استبدال» مستند مرفوض، أو «تذكير المصدّق» (تذكير واحد في اليوم كحد أقصى)، أو «إضافة تاريخ الانتهاء» (يفتح «تعديل التفاصيل»)، أو «تفتيش». وتصفّي «تصفية» حسب الحالة، والموقع، والفريق، ونوع الأصل، والمتطلب، وتاريخ الاستحقاق.",
        "2": "تُظهر التواريخ مصدرها: مقروءة من المستند، أو مقترحة من الذكاء الاصطناعي، أو مُدخلة يدويًا، ومن قبِلها."
      },
      "preview": {
        "screen": "الامتثال",
        "rows": {
          "0": "الغلاية 3 · سلامة الغاز · متأخر 4 أيام",
          "1": "الشاحنة 7 · الفحص الفني الدوري · ينتهي خلال 12 يومًا"
        },
        "highlight": "تجديد",
        "pin": "عالجه من الصف"
      }
    },
    "create-a-team": {
      "title": "أنشئ فريقًا",
      "summary": "أعدّ مساحة عمل مشتركة لزملائك.",
      "whyItMatters": "مساحة العمل المشتركة تعني أن العمل والأصول والسجل مرئية لكل من يحتاج إليها، ولا أحد غيرهم.",
      "timeEstimate": "دقيقتان",
      "intro": "الفريق مساحة عمل مشتركة. انتقل إلى «الحساب ← الفرق والدعوات»، وأنشئ فريقًا، ثم ادعُ الأشخاص وأسند الأصول إليه ليتمكن الجميع من التعاون.",
      "preview": {
        "screen": "إدارة الفريق",
        "rows": {
          "0": "لا يوجد فريق"
        },
        "highlight": "إنشاء فريق",
        "pin": "شارك مساحة عمل"
      }
    },
    "invite-members": {
      "title": "ادعُ الأعضاء",
      "summary": "أضف زملاءك إلى فريق كأعضاء أو مسؤولين.",
      "whyItMatters": "تعاون دون إفراط في المشاركة: ينضم كل شخص بالصلاحيات التي يحتاج إليها دوره بالضبط.",
      "timeEstimate": "دقيقتان",
      "intro": "يمكن لمالكي الفريق ومسؤوليه الضغط على «قم بدعوة الأشخاص»، وإدخال بريد إلكتروني واحد أو أكثر، واختيار «عضو» (يكمل العمل ويحدّثه) أو «المسؤول» (يدير الأشخاص والأدوار والإعدادات). يتلقى المدعوون رسالة بريد إلكتروني ويظهرون بعد قبولهم.",
      "paragraphs": {
        "0": "إذا لم تصل رسالة الدعوة، استخدم «نسخ رابط الدعوة» وأرسله بنفسك."
      },
      "preview": {
        "screen": "إدارة الفريق",
        "rows": {
          "0": "you@work.com · المسؤول"
        },
        "highlight": "قم بدعوة الأشخاص",
        "pin": "أضف الزملاء"
      }
    },
    "transfer-team-ownership": {
      "title": "انقل ملكية الفريق",
      "summary": "سلّم الفريق لشخص آخر، بموافقته.",
      "whyItMatters": "لا تقع الملكية على أحد فجأة، ولا يبقى فريق دون مالك عندما يغيّر الأشخاص أدوارهم.",
      "timeEstimate": "دقيقة واحدة",
      "intro": "يفتح المالك «إدارة الفريق» ويختار «نقل الملكية»، ثم يختار العضو الذي سيعرضها عليه.",
      "paragraphs": {
        "0": "يرى العضو العرض في الشاشة نفسها ويختار «قبول الملكية» أو «رفض». لا يتغير شيء حتى يقبل، وبعدها تصبح مسؤولًا. ويمكنك إلغاء عرض معلّق."
      },
      "preview": {
        "screen": "إدارة الفريق",
        "rows": {
          "0": "الإعدادات",
          "1": "نقل الملكية"
        },
        "highlight": "نقل الملكية",
        "pin": "اعرض، ثم اقبل"
      }
    },
    "contacts-overview": {
      "title": "جهات الاتصال والأدوار",
      "summary": "أضف الشخص المناسب دون مغادرة مهمتك.",
      "whyItMatters": "أضف الشخص المناسب أثناء سير العمل دون أي التفاف، ويحافظ اكتشاف التكرار على نظافة دليل جهات اتصالك.",
      "timeEstimate": "قراءة لمدة 3 دقائق",
      "intro": "جهات الاتصال هي الأشخاص والمؤسسات التي تعمل معها. يمكنك إضافتها مباشرة حيثما احتجت إليها، دون الانتقال إلى شاشة منفصلة.",
      "paragraphs": {
        "0": "يمكن أن تحمل جهة الاتصال عدة أدوار، مثل «مقاول»، و«مورّد»، و«مفتّش»، و«مستأجر»، و«ساكن»، و«سائق». تحدد الأدوار أين يمكن اختيارها: لا يمكن إسناد المهام أو توجيه دعوات تقديم عروض الأسعار إلا للمقاولين.",
        "1": "عندما تضيف جهة اتصال مباشرة (عند إسناد مهمة أو مشاركة أصل)، يتحقق AssetWRX من وجود تطابق محتمل حتى لا تنشئ الشخص نفسه مرتين.",
        "2": "ما يمكن لجهة الاتصال فعله على أصل مُشارَك تحدده المشاركة نفسها، «يمكنه العرض» أو «يمكنه الطلب»، لا دورها.",
        "3": "أعضاء الفريق (الأشخاص الذين لديهم تسجيل دخول في مساحة عملك) يختلفون عن جهات الاتصال (الأشخاص الذين تسجّلهم وتعمل معهم). راجع «أنشئ فريقًا» و«ادعُ الأعضاء» لمعرفة المزيد عن تسجيلات الدخول."
      }
    },
    "integrations-overview": {
      "title": "ربط الأنظمة الأخرى",
      "summary": "اربط البيانات، وأتمت العمليات، واستورد السجلات بتحديد النتيجة التي تريدها.",
      "whyItMatters": "اربط البيانات والأنظمة الأخرى حسب النتيجة، لا حسب الخبرة في الموصلات، واجلب سجلاتك الحالية مع معاينة قبل تغيير أي شيء.",
      "timeEstimate": "قراءة لمدة 3 دقائق",
      "intro": "تتيح التكاملات لـ AssetWRX تبادل البيانات مع الأنظمة الأخرى. يجدها مسؤولو مساحة العمل في «الحساب ← التكاملات»، بدءًا من «ما الذي تريد تحقيقه؟» لا من بنية الموصلات.",
      "paragraphs": {
        "0": "ابدأ ببساطة: اربط نظام أعمال آخر، أو تبادل الملفات، أو استورد السجلات من جدول بيانات. ثم تقدّم أكثر: تفاعل عندما يحدث شيء ما، أو أتمت مهمة، أو اربط أجهزة الاستشعار. ويمكن لفريق تقنية المعلومات لديك أيضًا ربط مساعد ذكاء اصطناعي أو بناء تطبيقه الخاص.",
        "1": "يطابق مستورد جداول البيانات أعمدتك مع حقول AssetWRX، ويعرض معاينة دقيقة لما سيُنشأ أو يُحدَّث، ثم يطبّقه.",
        "2": "تُدرج اتصالاتك تحت النتائج. أما «مرجع API»، وحسابات الخدمة والمفاتيح، و«الأدلة والوثائق» خطوة بخطوة، فتوجد تحت «المطورون والمراجع».",
        "3": "لعرض AssetWRX داخل بوابة أخرى، يختار مالك مساحة العمل «اعرض AssetWRX داخل بوابة أخرى» تحت «ما الذي تريد تحقيقه؟»."
      }
    },
    "plans-and-billing": {
      "title": "الخطط والفوترة",
      "summary": "افهم خطتك وأدِرها من شاشة واحدة.",
      "whyItMatters": "اعرف بالضبط ما تدفع مقابله وأدِره من شاشة واحدة، دون رسالة خاطئة تقول «أنت مشترك» قبل تأكيد الدفع فعلًا.",
      "timeEstimate": "قراءة لمدة 3 دقائق",
      "intro": "يفتح «الحساب ← الفوترة» شاشة «الفوترة والاستخدام»: خطتك، والأصول المحتسبة في الفوترة، والأرصدة، والاستهلاك في مكان واحد. ولا يمكن تغيير الإعدادات التجارية إلا لمسؤولي مساحة العمل.",
      "paragraphs": {
        "0": "أول أصل نشط لديك مجاني؛ وإضافة المزيد تبدأ اشتراكًا لتبدأ الفوترة. يمكنك تغيير الخطة أو إدارة اشتراكك من «الفوترة والاستخدام».",
        "1": "بعد العودة من صفحة الدفع، يعرض AssetWRX حالة الانتظار حتى يُؤكَّد دفعك في الخلفية، فشاشة «تم بنجاح» لدى مزوّد الدفع لا تمنح الوصول وحدها أبدًا.",
        "2": "إذا لم تكن مسؤولًا، يمكنك مراجعة الاستخدام، لكن المسؤول وحده يمكنه تغيير الخطة أو شراء الأرصدة."
      }
    },
    "ai-credits": {
      "title": "أرصدة الذكاء الاصطناعي",
      "summary": "كيف يُقاس استخدام الذكاء الاصطناعي، ولماذا لا يتوقف العمل أبدًا.",
      "whyItMatters": "اعرف ما يكفيك من أرصدة الذكاء الاصطناعي بنظرة واحدة، وواصل العمل حتى عند نفادها، لأن الذكاء الاصطناعي يحسّن سير العمل الأساسي فقط ولا يقيّده أبدًا.",
      "timeEstimate": "قراءة لمدة دقيقتين",
      "intro": "تستهلك ميزات الذكاء الاصطناعي (إنشاء قوائم التحقق، وتحسين الملاحظات، وتقارير الرؤى وغيرها) أرصدة الذكاء الاصطناعي. تتضمن خطتك حصة شهرية، ويمكن للمسؤولين شراء حزم أرصدة.",
      "paragraphs": {
        "0": "تعرض «الفوترة والاستخدام» الأرصدة المضمّنة والمشتراة، والاستهلاك الأخير، والمدة المتوقعة لكفايتها، فلا مفاجآت.",
        "1": "نفاد الأرصدة يوقف تحسينات الذكاء الاصطناعي مؤقتًا فقط، ولا يوقف العمل نفسه أبدًا. يمكنك دائمًا إكمال الأصول والفحوصات والطلبات والمهام يدويًا.",
        "2": "لا يُحتسب طلب الذكاء الاصطناعي الفاشل. وبعض الميزات تعمل على جهازك ولا تستهلك أي أرصدة على الإطلاق، مثل قراءة عداد من صورة."
      }
    },
    "using-the-assistant": {
      "title": "أنجز المهام مع المساعد",
      "summary": "اطرح الأسئلة، ودع المساعد يُعدّ تغييرات تؤكدها أنت.",
      "whyItMatters": "اسأل بكلماتك، كتابةً أو صوتًا أو بصورة، فيبحث المساعد ويُعدّ التغيير. لا يتغير شيء حتى تؤكده.",
      "timeEstimate": "قراءة 3 دقائق",
      "intro": "افتح المساعد من الشريط العلوي على الهاتف أو الجهاز اللوحي (وعلى الهاتف أيضًا من «المزيد ← المساعد»)، أو من الزر أسفل اليمين على الحاسوب. اطرح سؤالًا أو قل ما تريد إنجازه: «أضف الغرف 301 إلى 320 في الطابق 3»، «انقل فحص Boiler 1 إلى الجمعة»، «ما المتأخر هذا الأسبوع؟».",
      "paragraphs": {
        "0": "يستطيع إضافة الأصول والأماكن والمركبات والمواقع وتحديثها، وجدولة الفحوصات ونقلها، وإنشاء المهام وتغيير تفاصيلها وحالتها والمسؤول عنها، وإضافة التحديثات. الغرف أو العناصر الكثيرة دفعة واحدة تأتي في بطاقة واحدة توضح عدد الأصول المحتسبة التي ستُضاف.",
        "1": "كل تغيير بطاقة. راجعها، واضغط تعديل لتصحيح اسم أو تاريخ، ثم تأكيد. خلال الدقائق العشر التالية يمكنك الضغط على تراجع: يُؤرشف الجديد أو يُلغى، ويعود التعديل كما كان. لا يحذف المساعد أي شيء أبدًا.",
        "2": "يعمل باسمك: لا يرى ولا يغيّر إلا ما تستطيعه أنت، في مواقعك ومع تحققات تسجيل الدخول لديك. تظهر التغييرات التي تتم عبره بعبارة «عبر المساعد» في سجل العنصر وفي سجل التدقيق. يظهر الرد أثناء كتابته، وأثناء تحقق المساعد من سجلاتك ترى عدد ما بحث فيه. وتظهر التغييرات التي تمت عبره أيضًا في سجل المهام والمواقع، مع اسم من أكدها.",
        "3": "اضغط على الكاميرا بجانب الميكروفون لإرسال صورة للوحة بيانات أو عدّاد أو ضرر. يقرأ المساعد الصورة مرة واحدة وينسخ أي نص كما هو، ولا يحتفظ بها.",
        "4": "ويساعد في التخطيط أيضًا. اسأل \"من لديه عمل أكثر من طاقته هذا الأسبوع؟\" أو \"متى يمكن لسام إنجاز مهمة مدتها ساعتان؟\" أو \"كيف نحسن عمليات الفحص لدينا؟\" فيجيب استنادًا إلى ساعات العمل والإجازات والعمل المجدول، مع الدليل على كل اقتراح. اطلب منه تخطيط أسبوع شخص ما، أو التخطيط حول غياب شخص، فيفتح لوحة التخطيط جاهزة بذلك: ترى التغييرات ووقت التنقل الموفَّر، ولا يتغير شيء حتى تضغط تطبيق.",
        "5": "اسأل عن سير الأمور: \"كيف تطور الإنجاز في الموعد؟\" أو \"أي موقع كلف أكثر هذا الربع؟\" أو \"لماذا تتكرر التسربات في North Depot؟\". تأتي الإجابات من سجلاتك، مع رسم بياني صغير عند الحاجة. عندما تكون المحادثة فارغة، يعرض \"هذا الأسبوع\" أسبوعك وبعض الأسئلة؛ أخفه لهذا الأسبوع أو أوقفه، وأعد تشغيله من نشاط المساعد. اطلب تقريرًا فيفتح شاشة التقرير جاهزة للإنشاء؛ تعكس التقارير سجلاتك كما هي اليوم.",
        "6": "يعرف أين أنت. حدد بعض الأصول في القائمة واسأل «خطط عمليات الفحص لهذه»، فيعمل عليها هي بالضبط. أخبره بشيء يتذكره لمساحة العمل كلها، مثل «أعمال سلامة الغاز تذهب إلى Northside Heating»، فيتبعه من الآن؛ ويمكن للجميع رؤيته أو تغييره أو نسيانه في نشاط المساعد. بدون إشارة، ينتظر سؤالك ويُرسل عند عودتك إلى الاتصال، وتظهر فورًا مقالات دليل التطبيق التي قد تجيب عنه. اضغط على مكبر الصوت في الأعلى لتُقرأ الردود بصوت عالٍ، وفعّل «بدون استخدام اليدين» لتتحدث إليه دون لمس الشاشة. كلاهما يعمل الآن على الويب، ويصلان إلى تطبيق الهاتف والجهاز اللوحي مع تحديثه القادم في المتجر.",
        "7": "الحساب ← مساحة العمل ← نشاط المساعد يعرض كل تغيير تم عبر المساعد. يرى المالكون والمسؤولون تغييرات الجميع ويختارون من يمكنه إجراء التغييرات عبره: الجميع، أو المسؤولون فقط، أو لا أحد (فيجيب وينصح فقط).",
        "8": "كل رسالة تستهلك رصيدًا واحدًا من أرصدة الذكاء الاصطناعي؛ والإجابة الطويلة ذات عمليات البحث المتعددة تستهلك حتى ثلاثة، والصورة رصيدًا إضافيًا."
      },
      "preview": {
        "screen": "نشاط المساعد",
        "rows": {
          "0": "إنشاء أصل: غرفة 214 · تم",
          "1": "إعادة جدولة فحص · تم التراجع"
        },
        "highlight": "من يمكنه إجراء التغييرات",
        "pin": "أنت تؤكد كل تغيير"
      }
    },
    "notifications": {
      "title": "شغّل الإشعارات",
      "summary": "اعرف عندما يُسند إليك عمل أو ينتظرك.",
      "whyItMatters": "اعرف بالعمل الجديد والعاجل فورًا، دون أن تتفقد التطبيق.",
      "timeEstimate": "دقيقة واحدة",
      "intro": "في تطبيق الهاتف أو الجهاز اللوحي، افتح الجرس أو «الحساب ← التفضيلات» واضغط «تشغيل الإشعارات». تصل التنبيهات إلى التطبيق فقط؛ وعلى الويب يبقى الجرس يعرض كل شيء.",
      "paragraphs": {
        "0": "إذا رفضت من قبل، اضغط «فتح الإعدادات» واسمح بالإشعارات لـ AssetWRX.",
        "1": "في «الحساب ← التفضيلات»، اختر ما تريد أن تُبلَّغ به، مثل «المُسنَد إليّ» و«الرسائل» و«الموافقات والطلبات»، وحدّد «ساعات هادئة».",
        "2": "يعرض الجرس كل شيء في مكان واحد. اضغط عنصرًا لفتحه، أو أجّله ليعود إليك لاحقًا."
      }
    },
    "request-a-feature": {
      "title": "طلب ميزة",
      "summary": "أخبر فريق AssetWRX بما يجب أن يفعله التطبيق لاحقًا، وتابع ما يحدث لطلبك.",
      "whyItMatters": "من يستخدم AssetWRX كل يوم يعرف أكثر من غيره ما ينقصه. نقرأ كل طلب، وتصلك الإجابة.",
      "timeEstimate": "دقيقتان",
      "intro": "افتح الحساب ← المساعدة واضغط طلب ميزة. قل ما تريده وكيف سيساعدك، واختر جزء التطبيق ومدى أهميته.",
      "paragraphs": {
        "0": "يمكنك إضافة حتى ثلاث لقطات شاشة. لا تُظهر بيانات شخصية أو بيانات العملاء. تحت يُرسل مع طلبك ترى بالضبط ما يُرسل معه: إصدار التطبيق وجهازك ولغتك والشاشة التي جئت منها.",
        "1": "يصل الطلب إلى فريق AssetWRX فقط، ولا يصل أبدًا إلى مساحة عملك أو إلى عملاء آخرين. إذا طلبت شيئًا مشابهًا من قبل، يعرضه النموذج حتى لا ترسله مرتين.",
        "2": "تعرض طلباتك في المساعدة ما أرسلته مع حالته: قيد المراجعة، مخطط له، قيد التطوير، متاح في التطبيق الآن، أو غير مخطط له حاليًا، مع أي رد من الفريق. يصلك إشعار عند تغيّرها؛ أوقف أخبار المنتج من الحساب ← التفضيلات في تطبيق الهاتف أو الجهاز اللوحي إذا لم ترغب في ذلك.",
        "3": "تعرض أفكار ندرسها أفكارًا كتبها الفريق. اضغط أريد هذا للتصويت، وسنخبرك عندما تتقدم الفكرة.",
        "4": "يمكنك أيضًا أن تقول للمساعد «أتمنى لو يستطيع التطبيق…». سيصيغ الطلب لترسله أو تعدّله أولًا في النموذج."
      },
      "preview": {
        "screen": "طلب ميزة",
        "rows": {
          "0": "ماذا تريد؟",
          "1": "كيف سيساعدك ذلك؟",
          "2": "أي جزء من التطبيق؟ · التقارير"
        },
        "highlight": "إرسال الطلب",
        "pin": "يقرؤه الفريق"
      }
    },
    "staying-productive-offline": {
      "title": "العمل دون اتصال والاستعادة بأمان",
      "summary": "واصل العمل رغم انقطاع الاتصال واستعد عملك بسلاسة.",
      "whyItMatters": "العمل الميداني لا يتوقف عندما تنقطع الإشارة: يُحفظ عملك ويُزامن عند عودتك، ولا تنتهي الروابط أبدًا إلى طريق مسدود.",
      "timeEstimate": "قراءة لمدة 3 دقائق",
      "intro": "صُمّم AssetWRX ليُبقيك تتقدم رغم بطء التشغيل وانقطاع الاتصال وحدود الصلاحيات: يُحفظ عملك ويُزامن عند عودتك إلى الإنترنت.",
      "paragraphs": {
        "0": "تُحفظ الإجراءات المدعومة على جهازك وتُزامن تلقائيًا عند عودة الاتصال، ويمكنك رؤية حالتها: «محفوظ محليًا»، أو «جارٍ المزامنة»، أو «تمت المزامنة»، أو «يحتاج إلى انتباه»، أو «يلزم الاتصال بالإنترنت». وعندما تكون هناك تغييرات بانتظار الإرسال، تعرض الرئيسية «تغييرات لم تُرسل»، التي تسرد كل ما ينتظر الإرسال، مع «أرسل الآن».",
        "1": "الفشل القابل لإعادة المحاولة لا يمحو أبدًا ما أدخلته أو أدلتك. والإجراءات التي تحتاج فعلًا إلى اتصال تُعلمك قبل أن تبدأ، بدلًا من ضياع جهدك.",
        "2": "يمكنك بدء أمر العمل وإيقافه مؤقتًا وإكماله، وإيقاف الفحص مؤقتًا وإكماله، دون إشارة. يظهر «محفوظ محليًا» ويُرسل عند عودتك متصلًا ثم يُتحقق منه مجددًا؛ وإذا غيّره شخص آخر في الأثناء، يظهر «يحتاج إلى انتباه» بدل الكتابة فوق تغييره. يمكنك أيضًا بدء فحص جديد على أصل فتحه هذا الجهاز من قبل؛ ويُرسل عند عودتك متصلًا.",
        "3": "تفتح روابط الإشعارات السجل نفسه، أو شاشة استعادة آمنة إن كان قد نُقل أو لم يكن لديك وصول إليه، ولا تنتهي أبدًا إلى طريق مسدود. وتشرح الميزات المتاحة للقراءة فقط أو غير المتاحة السبب، وتوجّهك إلى الخطوة التالية الصحيحة."
      }
    }
  }
};
